import moment from 'moment';
import validator from 'validator';
import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Input from 'react-phone-number-input/input';
import { useSelector, useDispatch } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMemo, useEffect, useState, useRef } from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import Button from './common/Button';
import EnterCode from './modals/enterCode';
import OpenRModal from './modals/openRModal';
import * as ROUTES from '../constants/routes';
import ProgressBar from './progress/ProgressBar';
import AddCompanyModal from './modals/addCompany';
import CreateGroupModal from './modals/createGroup';
import { updateUser } from '../reducers/userReducer';
import ModalWrapper from './common/Modal/ModalWrapper';
import FileLoaderModal from './modals/fileLoaderModal';
import PasswordUpdated from './modals/passwordUpdated';
import ImportSummaryModal from './modals/importSummary';
import ChooseAuthMethodModal from './modals/chooseAuthMethod';
import CreateGroupInfo from './modals/createGroup/Information';
import { setModalHistory, toggleModal } from '../reducers/modalReducer';
import ResendForgotPasswordEmail from './modals/resendForgotPasswordEmail';
import { setLogout, token, setToken, getRequest, postRequest, showMessage, } from '../config';
import { COMPANY, DASHBOARD, ADVISOR, BILLING, LOGGED_IN_ROUTES, INVESTOR, } from '../constants/routes';
import SyncingProgress from './modals/SyncingProgress';

let passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;
const INVALID_PASSWORD_MSG = 'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.';

export default function Popups() {
  let dispatch = useDispatch();
  let navigation = useNavigate();
  let location = useLocation();

  let user = useSelector((state) => state.user);
  let modal = useSelector((state) => state.modal);

  let companies = useSelector(state => state.companies);
  let loginType = useSelector((state) => state.loginType);
  let { syncing, message } = useSelector((state) => state.appData);

  let [hash, setHash] = useState();
  let [step, setStep] = useState(1);
  let [tooltip, setTooltip] = useState();
  let [counter, setCounter] = useState(0); // Countdown for 60s
  let [company, setCompany] = useState({});
  let [isPlay, setIsPlay] = useState(false);
  let [loading, setLoading] = useState(false);
  let [stepNo, setStepNo] = useState('Step1'); // Step1, Step2, Step3, Step4
  let [loginFor, setLoginFor] = useState(null);
  let [authMethod, setAuthMethod] = useState();
  let [smsEnabled, setSmsEnabled] = useState();
  let [attachment, setAttachment] = useState([]);
  let [isBilling, setIsBilling] = useState(false);
  let [accordion, setAccordion] = useState('one');
  let [twoFaEnabled, setTwoFaEnabled] = useState();
  let [emailEnabled, setEmailEnabled] = useState();
  let [isFireWork, setIsFireWork] = useState(false);
  let [resNewAdvisor, setResNewAdvisor] = useState();
  let [bugDescription, setBugDescription] = useState();
  let [passwordType, setPasswordType] = useState(false);
  let [parentCompany, setParentCompany] = useState(null);
  let [companiesGroup, setCompaniesGroup] = useState({}); // { companyId: '', group: '', percentage: '' }
  let [companyOptions, setCompanyOptions] = useState([]);
  let [existingCompany, setExistingCompany] = useState();
  let [selectedCompany, setSelectedCompany] = useState({});
  let [confirmedCompany, setConfirmedCompany] = useState();
  let [websiteStatus, setWebsiteStatus] = useState('Check');
  let [existingInvestor, setExistingInvestor] = useState({});
  let [editDescription, setEditDescription] = useState(false);
  let [accessGrantedData, setAccessGrantedData] = useState({});
  let [advisorAccessData, setAdvisorAccessData] = useState(null);
  let [profileClass, setProfileClass] = useState('client-profile');
  let [isDescriptionLogin, setIsDescriptionLogin] = useState(false);
  let [previousCompanyDeleted, setPreviousCompanyDeleted] = useState(false);
  let [applicant, setApplicant] = useState({ firstName: '', lastName: '', email: '' }); // Add Applicant Manual Investor Match
  let [formData, setFormData] = useState({ role: 'Advisor', firstName: '', lastName: '', email: '', password: '', designation: '', phone: '', firmName: '', firmAddress: '', website: '', firmLogo: '' });



  const buttonText = useMemo(() => {
    return counter > 0 ? `Resend in ${counter}s` : 'Resend Code';
  }, [counter]);

  const handleToDashboard = (role) => {
    dispatch(toggleModal({ open: '' }))
    if (user) {
      role = user['role']
    }

    if (role) {
      navigation(role.toLowerCase() === 'advisor'
        ? '/advisor-dashboard'
        : (role.toLowerCase() === 'user' || role.toLowerCase() === 'member')
          ? '/dashboard'
          : '/investor-dashboard')
    }
  };

  const isButtonDisabled = useMemo(() => {
    return counter > 0 || loading;
  }, [counter, loading]);

  useEffect(() => {
    let timer;
    if (counter > 0) {
      timer = setTimeout(() => setCounter(counter - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [counter]);

  let tooltipRef = useRef(tooltip);

  const handleDisclaimer = async () => {
    let urlParams = new URLSearchParams(location?.search);
    let source = urlParams.get('source');

    if (user?.['type'] == 'Superflow' && user?.['partnerId'] && source == 'externalApi') dispatch(toggleModal({ open: '' }));
    else if (user?.['type'] == 'Superflow' && user?.['partnerId']) dispatch(toggleModal({ open: 'addCompany' }));
    else dispatch(toggleModal({ open: 'introVideo' }));
    try {
      const res = await postRequest(`/user/updateProfile`, { ...user, isAgreeWithDisclaimer: true });
      localStorage.setItem('isAgreeWithDisclaimer', true);
      dispatch(updateUser({ ...user, isAgreeWithDisclaimer: true }));
    } catch (e) {
      console.error(e);
    }
  };

  const handleLogoutClose = () => dispatch(toggleModal({ open: '' }));
  function playVideo(e) {
    let video = document.getElementById("videoPaul");
    if (video.paused == true) {
      setIsPlay(true);
      video.play();
    }
    e.target.controls = true;
    if (e?.target?.nextElementSibling) e.target.nextElementSibling.remove();
  };

  let searchTimeout;
  useEffect(() => {
    (async () => {
      // Login with hash token
      if (location.pathname.includes('hashToken')) {
        const pathParts = location.pathname.split('/');
        const hashIndex = pathParts.indexOf('hashToken');
        const companyIndex = pathParts.indexOf('company');

        if (hashIndex !== -1 && companyIndex !== -1) {
          const hash = pathParts[hashIndex + 1];
          const companyId = pathParts[companyIndex + 1];
          if (hash && companyId) {
            setToken(hash);
            localStorage.setItem('token', hash);

            const hashFragment = window.location.hash || '';
            setTimeout(() => navigation(`/company/${companyId}${hashFragment}`), 1000);
          }
        }
      }
      // Grant investor access
      if (location.pathname.includes('investorToken')) {
        const hash = location.pathname.split('/').slice(-1)[0];
        let stringVersion = new Buffer(hash, 'base64').toString();
        let data = stringVersion.split('&&&');

        let linkData = {
          hash: data[1],
          firmId: data[2],
          firmName: data[3],
          contactName: data[4],
          userFirstName: data[5],
          userLastName: data[6],
          userEmail: data[7]
        };

        setAccessGrantedData({
          investorName: linkData['firmName'],
          contactName: linkData['contactName'],
          userFirstName: linkData['userFirstName'],
          userLastName: linkData['userLastName'],
          userEmail: linkData['userEmail'],
        });

        if (linkData['hash']) {
          setToken(linkData['hash']);
          localStorage.setItem('token', linkData['hash']);

          let res;
          if (data[8] == 'Company') res = await getRequest(`/user/companyAccess/${hash}`);
          else res = await postRequest(`/user/investorAccess`, { hash });
          if (res && res['code'] == 200) dispatch(toggleModal({ open: 'accessGranted' }));
        }
      }

      if (location.pathname.includes('advisorToken')) {
        const hash = location.pathname.split('/').slice(-1)[0];
        let stringVersion = new Buffer(hash, 'base64').toString();
        let data = stringVersion.split('_');
        let linkData = {
          companyOwnerId: data[1],
          advisorId: data[2],
          companyId: data[4],
          userName: `${data[6]} ${data[7] ?? ""}`,
          companyName: data[8]
        }
        setAdvisorAccessData(linkData)
        let res = await getRequest(`/user/advisorAccess/${hash}`, "return-response");
        console.log(res, "res")
        if (res && res['code'] == 200) {
          dispatch(toggleModal({ open: 'advisorAccessGranted' }));
        } else {
          showMessage(res['message'])
          handleToDashboard(res['body']['role'])
        }
      }

      // Verify email addess
      if (location.pathname.includes('verifyEmail')) {
        const hash = location.pathname.split('/').slice(-1)[0];
        const response = await getRequest(`/user/verifyEmail/${hash}`);
        if (response && response['code'] == 200) {
          showMessage(response['message']);
          loginWithToken(response.body);
        }
      }
      if (location.pathname.includes('newAdvisorCompany')) {
        // Logout if logged in
        if (token) await setLogout(false);
        const hash = location.pathname.split('/').slice(-1)[0];
        const response = await getRequest(`/user/access/${hash}`);
        if (response && response['code'] == 200) {
          await setResNewAdvisor(response['body']);
          dispatch(toggleModal({ open: 'newAdvisorAdded' }));
        }
      }
      if (location.pathname.includes('newInvestorCompany')) {
        // Logout if logged in
        if (token) await setLogout(false);
        const hash = location.pathname.split('/').slice(-1)[0];
        const response = await getRequest(`/user/access/${hash}`);
        if (response && response['code'] == 200) {
          await setResNewAdvisor(response['body']);
          dispatch(toggleModal({ open: 'newInvestorCompany' }));
        }
      }
      if (location.pathname.includes('verifyAdvisor')) {
        // Logout if logged in
        if (token) setLogout();
        const hash = location.pathname.split('/').slice(-1)[0];
        let stringVersion = new Buffer(hash, 'base64').toString();
        let code = stringVersion.split('_')[2];

        if (code) window.location.href = `/reset_password/${code}`;
      }
    })();

    if (user) setProfileClass(user['role'] == 'Advisor' ? 'advisor-profile' : user['role'] == 'Investor' ? 'investor-profile' : 'client-profile')
    if (location.pathname.includes('newMember')) setTimeout(() => dispatch(toggleModal({ open: 'newMember' })), 1000);
    // else if (location.pathname.includes('reset_password')) setTimeout(() => dispatch(toggleModal({ open: 'newPassword' })), 1000);

    const globalClickListeners = (e) => {
      if (e.target.dataset.popup)
        console.log('********click-outside-hidePopup');
      // else if (e.target.dataset.showPopup)
      // 	showPopup(e.target.dataset.showPopup)
      else if (e.target.dataset.scrollTo) {
        const id = e.target.dataset.scrollTo;
        const el = document.getElementById(id);
        const isLoggedInPage = LOGGED_IN_ROUTES.find((r) =>
          r
            .split('/')
            .every(
              (s, i) => s === location.pathname.split('/')[i] || s[0] === ':'
            )
        );
        if (el) {
          const top =
            pageYOffset +
            el.getBoundingClientRect().top -
            (isLoggedInPage
              ? 0
              : document.querySelector('header').offsetHeight) -
            16;
          scrollTo({ top, behavior: 'smooth' });
        }
      } else if (e.target.classList.contains('toggleHeight')) {
        const [textEl, el] = e.target.children;
        if (!el || !textEl) return;
        if (
          textEl.innerText.includes('Show') ||
          textEl.innerText.includes('Hide')
        ) {
          const bg = window
            .getComputedStyle(textEl, null)
            .getPropertyValue('background-color');
          textEl.style.color = bg;
          setTimeout(() => {
            if (textEl.innerText.includes('Show'))
              textEl.innerText = textEl.innerText.replace('Show', 'Hide');
            else if (textEl.innerText.includes('Hide'))
              textEl.innerText = textEl.innerText.replace('Hide', 'Show');
            textEl.style.color = '';
          }, 250);
        }
        const height = el.scrollHeight;
        const ms = 250 + (height > 1500 ? 1500 : height) / 2;
        el.style.transitionDuration = ms + 'ms';
        if (el.style.height == '0px') {
          el.style.height = height + 'px';
          setTimeout(() => {
            el.style.transitionDuration = '';
            el.style.height = '';
          }, ms);
        } else {
          el.style.height = height + 'px';
          setTimeout(() => (el.style.height = '0px'), 0);
          setTimeout(() => (el.style.transitionDuration = ''), ms);
        }
      }
    };

    //TODO: use framer motion to animate
    const globalMouseMoveListeners = (e) => {
      if (tooltipRef.current && !e.target.dataset.tooltipId) {
        let tooltipId = tooltipRef.current.id.replace('tooltip-', '');
        const el = document.querySelector(`[data-tooltip-id='${tooltipId}']`);
        if (el) delete el.dataset.tooltipId;
        setTooltip(undefined);
      }

      if (e.target.dataset.tooltip && !e.target.dataset.tooltipId) {
        const tooltipId = Math.floor(Math.random() * 1000000);
        e.target.dataset.tooltipId = tooltipId;
        setTooltip({
          id: 'tooltip-' + tooltipId,
          y: e.clientY,
          x: e.clientX,
          html: e.target.dataset.tooltip,
        });
      } else if (
        tooltipRef.current &&
        e.target.dataset.tooltip &&
        e.target.dataset.tooltipId
      ) {
        setTooltip({
          ...tooltipRef.current,
          y: e.clientY,
          x: e.clientX,
        });
      }
    };

    addEventListener('click', globalClickListeners);
    addEventListener('mousemove', globalMouseMoveListeners);
    return () => {
      removeEventListener('click', globalClickListeners);
      removeEventListener('mousemove', globalMouseMoveListeners);
    };
  }, []);

  useEffect(() => {
    tooltipRef.current = tooltip;
    if (tooltip) {
      const tooltipEl = document.getElementById(tooltip.id);
      const newTooltip = { ...tooltip };
      let updateTooltip = false;
      if (
        tooltipEl?.offsetHeight + parseInt(tooltipEl?.style.top) >
        innerHeight
      ) {
        newTooltip.y = innerHeight - tooltipEl?.offsetHeight;
        updateTooltip = true;
      }
      if (
        tooltipEl?.offsetWidth + parseInt(tooltipEl?.style.left) >
        innerWidth
      ) {
        newTooltip.x = innerWidth - tooltipEl?.offsetWidth;
        updateTooltip = true;
      }
      if (updateTooltip) setTooltip(newTooltip);
    }
  }, [tooltip]);

  useEffect(() => {
    setSmsEnabled(loginType.smsEnabled);
    setTwoFaEnabled(loginType.twoFaEnabled);
    setEmailEnabled(loginType.emailEnabled);
    setHash(loginType.hash);
  }, [loginType]);

  useEffect(() => {
    if (!hash) return;
    if (smsEnabled + twoFaEnabled + emailEnabled > 1)
      dispatch(toggleModal({ open: 'chooseAuthMethod' }));
    else if (smsEnabled) loginWithSMS();
    else if (twoFaEnabled) loginWithTwoFA();
    else if (emailEnabled) loginWithEmail();
  }, [hash, smsEnabled, twoFaEnabled, emailEnabled]);

  const searchCompanyTimeout = (e) => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => searchCompany(e.target.value), 1000);
  };

  const proceedCompany = async (company) => {
    if (user?.['type'] == 'Superflow' && user?.['partnerId']) {
      let data = {
        partnerId: user['partnerId'],
        category: 'partner',
        companies: { [company['_id']]: company['cName'] },
        memberPermissions: { [user['_id']]: { ...user, company: { [company['_id']]: company['cName'] } } }
      }

      const res = postRequest(`/checklist/create/0`, data);
      if (res?.['code'] == 200) showMessage(res?.['message']);
    }

    if (user['_id'] && user?.['emailVerified'] && company?.['_id'] && company?.['cName'] && user?.['type'] == 'User' && company?.['testType'] == 'investment') {
      let res = await getRequest(`/checklist/partner/KPMG`);
      if (res['code'] == 200 && res?.['body']?.['_id']) {
        let partnerId = res['body']['_id'];
        let data = {
          partnerId,
          category: 'partner',
          companies: { [company['_id']]: company['cName'] },
          memberPermissions: { [user['_id']]: { ...user, company: { [company['_id']]: company['cName'] } } }
        }
        const response = postRequest(`/checklist/create/0`, data);
      }
    }


    if (window.location.pathname.includes(DASHBOARD)) window.location.reload();
    else if (window.location.pathname.includes('advisor-dashboard') || window.location.pathname.includes('investor-dashboard')) dispatch(toggleModal({ open: 'checkAccessCompany' }));
    else if (window.location.pathname.includes('demoChecklist')) window.location.href = `/demoChecklist?companyId=${company['_id']}&cName=${company['cName']}`;
    else if (window.location.pathname.includes('partnerChecklist')) window.location.href = `${window.location.pathname}?companyId=${company['_id']}&cName=${company['cName']}`;
    else if (window.location.pathname.includes('superFlow') && user?.['type'] == 'Superflow') window.location.href = `/company/${company['_id']}#investor-lead`;
    else if (window.location.pathname.includes('manualAdd') && user?.['role'] == 'Investor') { localStorage.setItem('isManualAdd', true); window.location.href = `/company/${company['_id']}#investor-lead` }
    else if (localStorage.getItem('testType')) window.location.href = COMPANY.replace(':id', company['_id']) + '#two-minute-test-' + company['testType'];
    else window.location.href = BILLING.replace(':id', company['_id']);
  };

  const searchCompany = async (input) => {
    if (!input) return;

    const response = await getRequest(`/company/search/${input}`);
    if (!response || response['code'] != 200) return;
    setCompanyOptions(response['body']['items'].slice(0, 5));
  };

  const login = async () => {
    const email = document.getElementById('loginEmail').value;
    const password = document.getElementById('loginPassword').value;
    if (email && password) {
      //TODO: add email validation
      setLoading(true)
      const postBody = { email, password };
      const response = await postRequest('/user/auth', postBody);
      // TODO: if userId, code and authMethod aren't sent, server should send _id, smsEnabled, emailEnabled and twoFaEnabled
      if (response && response['code'] == 200) {
        if (response['body']['token']) {
          showMessage(response['message']);
          loginWithToken(response['body']);
          dispatch(toggleModal({ open: '' }));
        }
        else if (response['body']['hash']) {
          let data = response['body'];
          setSmsEnabled(data.smsEnabled);
          setTwoFaEnabled(data.twoFaEnabled);
          setEmailEnabled(data.emailEnabled);
          setHash(data.hash);
        }
        setLoading(false);
      }
      else setLoading(false);
    } else { showMessage('Enter your email and password'); }
  };

  const resendCode = () => {
    if (authMethod === 'Email') loginWithEmail();
    else if (authMethod === 'Phone') loginWithSMS();
    setCounter(60);
  };

  const loginWithToken = async (data) => {
    for (const key of ['token']) //'role'
      document.cookie = `${key}=${data[key]};path=/`;
    setToken(data['token']);
    localStorage.setItem('token', data['token']);
    if (loginType?.redirect && data['role']) {
      setTimeout(() => window.location.replace(`/${loginType?.redirect}`), 100);
      return;
    }
    if (data['role'] !== 'Admin' && isBilling) window.location.href = BILLING.replace(':id', data?._id);

    if (data['type'] == 'Superflow' && data['partnerId']) {
      let res = await getRequest(`/user/myProfile`);
      if (res['code'] == 200) {
        let { companies } = res['body'];
        if (companies.length > 0) navigation(DASHBOARD);
        else window.location.href = `/superFlow/${data['partnerId']}`
      }
    }
    else if (data['role'] == 'Advisor') navigation(ADVISOR);
    else if (data['role'] == 'Admin') setTimeout(() => navigation('/admin'), 100);
    else if (data['role'] == 'Investor') setTimeout(() => navigation(INVESTOR), 100);
    else setTimeout(() => navigation(DASHBOARD), 100);
  };

  const loginWithEmail = async () => {
    setLoading(true);
    const response = await getRequest('/user/loginEmail/' + hash);
    showMessage(response.message);
    if (response['code'] != 200) return setLoading(false);
    setAuthMethod('Email');
    dispatch(toggleModal({ open: 'enterCode' }));
    setLoading(false);
  };

  const loginWithSMS = async () => {
    setLoading(true);
    const response = await getRequest(`/user/loginSms/${hash}`);
    showMessage(response.message);
    if (response['code'] != 200) return setLoading(false);
    setAuthMethod('Phone');
    dispatch(toggleModal({ open: 'enterCode' }));
    setLoading(false);
  };

  const loginWithTwoFA = () => {
    setLoginFor("google")
    setAuthMethod('App');
    dispatch(toggleModal({ open: 'enterCode' }));
  };

  const codeEntered = async (e) => {
    try {
      const authKey = e.target.value;
      if (authKey.length < 6) return;
      setLoading(true);
      const response = await postRequest(`/user/verifyAuthLogin/${hash}`, { authKey, authMethod });
      showMessage(response['message']);
      if (response['code'] == 200) {
        dispatch(toggleModal({ open: '' }));
        setTimeout(() => loginWithToken(response['body']), 500);
      } else e.target.value = '';
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false);
    }
  };

  const register = async () => {
    const firstName = document.getElementById('registerFirstName').value;
    const lastName = document.getElementById('registerLastName').value;
    const email = document.getElementById('registerEmail').value;
    const password = document.getElementById('registerPassword').value;
    const agree = document.getElementById('registerTerms').checked;
    if (firstName && lastName && email && password) {
      if (!agree) return showMessage('Please accept the terms & conditions');
      setLoading(true)
      const response = await postRequest('/user', { firstName, lastName, email, password });
      if (response && response['code'] == 200) {
        dispatch(toggleModal({ open: 'registerVerification' }));
        setLoading(false);
        showMessage(response['message']);
      } else setLoading(false);
    } else showMessage('Please fill out all fields');
  };

  const confirmAdvisorCompany = async () => {
    let response = await postRequest(`/company/checkExistingCompany`, { ukRegNo: selectedCompany['company_number'] });
    if (response['code'] == 200) {
      if (Object.keys(response['body']).length > 0) {
        if (!['client', 'advisor'].includes(response['body']?.['cCategory'])) {
          showMessage(response['message']);
          setExistingInvestor(response['body']);
          dispatch(toggleModal({ open: 'existingInvestor' }));
        } else showMessage(`This is ${response['body']?.['cCategory']} company. You can't add it.`);
      } else {
        setStepNo('Step3');
        setFormData({
          ...formData,
          cType: selectedCompany['type'],
          firmName: selectedCompany['title'],
          ukRegNo: selectedCompany['company_number'],
          firmAddress: selectedCompany['address_snippet'],
          doIncorporation: selectedCompany['date_of_creation'],
        });
      }
    }
  };

  const requestInvestorAccess = async () => {
    let data = {
      firmId: existingInvestor['_id'],
      firmName: existingInvestor['cName'],
      contactId: existingInvestor['contactId'],
      contactName: existingInvestor['contactName'],
      contactEmail: existingInvestor['contactEmail'],
      userFirstName: formData['firstName'],
      userLastName: formData['lastName'],
      userEmail: formData['email'],
    };

    let response = await postRequest(`/company/requestInvestorAccess`, data);
    if (response['code'] == 200) {
      showMessage(response['message']);
      setStepNo('Step1');
      dispatch(toggleModal({ open: '' }));
    }
  };

  const handlePhoneChange = (value) => setFormData({ ...formData, phone: value });
  const handleChange = (event) => {
    if (modal['open'] == 'registerInvestor') setFormData((prev) => ({ ...prev, role: 'Investor' }));
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value, }));
  };

  const onDragOver = (e) => e.preventDefault();
  const onDrop = (e) => {
    e.preventDefault();
    const logo = e.dataTransfer.files[0];
    let maxSizeInBytes = 5 * 1024 * 1024;
    if (logo) {
      let logoUrl = URL.createObjectURL(logo);
      let img = document.createElement('img');
      img.src = logoUrl;
      img.onload = () => {
        // if (img.width > 160 || img.height > 160) {
        // 	showMessage('Image Dimensions Required (160 x 160)');
        // 	setFormData(prevFormData => ({ ...prevFormData, firmLogo: '' }));
        // 	return;
        // } else
        if (logo.size > maxSizeInBytes) {
          showMessage(`File size must be less than 1MB`);
        } else {
          setFormData((prevFormData) => ({
            ...prevFormData,
            firmLogo: logoUrl,
          }));
        }
      };
    }
  };

  const handleRegister = async () => {
    if (formData['firmName'] === '') showMessage('Please fill out Firm Name');
    else if (formData['firmAddress'] === '') showMessage('Please fill out the Firm Address');
    else if (formData['designation'] === '') showMessage('Please fill out your designation');
    else if (formData['phone'] === '') showMessage('Please fill out phone Number');
    else if (formData['website'] === '') showMessage('Please fill out the website');
    else if (!validator.isURL(formData['website'])) showMessage('Please enter valid webiste URL');
    else {
      const response = await postRequest('/user/advisor', { attachment, ...formData }, false);
      if (response && response['code'] == 200) {
        await setCompany(response['body']);
        dispatch(toggleModal({ open: '' }));
        if (response['body']['companyDescription']) {
          setIsDescriptionLogin(true);
          dispatch(toggleModal({ open: 'confirmDescription' }));
        }

        setStepNo('Step1');
        showMessage(response['message']);
        setFormData({ role: 'Advisor', firstName: '', lastName: '', email: '', password: '', designation: '', phone: '', firmName: '', firmAddress: '', website: '', firmLogo: '' });
      }
    }
  };

  const handleImageChange = async (event) => {
    let logo = event.target.files[0];
    if (event.target.files) {
      const newAttachment = [];
      for (const file of event.target.files)
        newAttachment.push(file);
      setAttachment(newAttachment);
    }
    // let attachment = [];
    let maxSizeInBytes = 5 * 1024 * 1024;
    if (logo) {
      let logoUrl = URL.createObjectURL(logo);
      let img = document.createElement('img');
      img.src = logoUrl;
      img.onload = () => {
        if (logo.size > maxSizeInBytes)
          showMessage(`File size must be less than 5Mb`);
        else {
          setFormData((prevFormData) => ({
            ...prevFormData,
            firmLogo: logoUrl,
          }));
          // attachment.push(logo);
        }
      };
    }
  };

  const closePopup = () => {
    dispatch(toggleModal({ open: '' }));
    setFormData({ role: 'Advisor', firstName: '', lastName: '', email: '', password: '', designation: '', phone: '', firmName: '', firmAddress: '', website: '', firmLogo: '' });
    setStepNo('Step1');
  };

  const forgotPassword = async () => {
    const email = document.getElementById('forgotPasswordEmail').value;
    //TODO: add email validation
    if (!email) {
      showMessage('Enter your email');
      return;
    }
    let response = await postRequest('/user/forgotPassword', { email });
    if (response && response['code'] == 200) showMessage(response['message']);
  };

  const setMemberPassword = async () => {
    const password = document.getElementById('newMemberPassword').value;

    if (!location.pathname.includes('newMember')) {
      showMessage('Invalid request try link from email');
      return;
    }

    if (passwordPattern.test(password) == false) {
      showMessage(INVALID_PASSWORD_MSG);
      return;
    }

    let params = location.pathname.split('/');
    let hash = params[params.length - 1];

    let response = await postRequest(`/user/newMemberPwd`, { hash, password });
    if (response && response['code'] == 200) {
      showMessage(response['message']);
      window.location.href = `/login`;
    }
  };

  const verifyWebsite = async () => {
    try {
      let companyWebsite = document.querySelector(`#companyWebsite`).value;
      if (!companyWebsite) return showMessage('Please provide website link');
      if (!isURL(companyWebsite)) return showMessage('Invalid company url');
      if (companyWebsite.indexOf('http') < 0)
        companyWebsite = `http://${companyWebsite}`;

      openWindow(companyWebsite);
      setWebsiteStatus('Confirm');
    } catch (e) {
      return showMessage(e);
    }
  };

  function isURL(str) {
    var pattern = new RegExp(
      '^((ft|htt)ps?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?' + // port
      '(\\/[-a-z\\d%@_.~+&:]*)*' + // path
      '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return pattern.test(str);
  };

  const openWindow = (url) => {
    if (window.innerWidth <= 640) {
      // var a = document.createElement('a');
      // a.setAttribute('href', url);
      // a.setAttribute('target', '_blank');

      // var dispatch = document.createEvent('HTMLEvents');
      // dispatch.initEvent('click', true, true);

      // a.dispatchEvent(dispatch);

      window.open(url, '_blank');
    } else {
      var width = window.innerWidth * 0.8;
      var height = (width * window.innerHeight) / window.innerWidth;
      window.open(url, 'newwindow', 'width=' + width + ', height=' + height + ', top=' + (window.innerHeight - height) / 2 + ', left=' + (window.innerWidth - width) / 2);
    }
    return false;
  };

  const updateDescription = async () => {
    const companyDescription =

      document.getElementById('companyDescription').value;
    if (!companyDescription)
      return showMessage('Please input update description');

    const response = await postRequest(`/company/description/${company['_id']}`, { companyDescription });
    showMessage(response['message']);
    if (response?.['code'] != 200) return;

    company['companyDescription'] = companyDescription;
    setCompany(company);
    setEditDescription(false);
  };

  const intercom = () => {
    window.intercomSettings = {
      app_id: 'qp54mmn4',
      api_base: 'https://api-iam.intercom.io',
      user_id: user['_id'] ? user['_id'] : null,
      name: user['firstName'] ? user['firstName'] + ' ' + user['lastName'] : null,
      email: user['email'] ? user['email'] : null,
      phone: user['phone'] ? user['phone'] : null,
      created_at: user['createdAt'] ? moment(user['createdAt']).format('X') : null,
    };
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = () => i.c(arguments);
      i.q = [];
      i.c = (args) => i.q.push(args);
      w.Intercom = i;
      var l = () => {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/qp54mmn4';
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') l();
      else if (w.attachEvent) w.attachEvent('onload', l);
      else w.addEventListener('load', l, false);
    }
  };

  const ADVISOR_FORM_CHECK = ['firstName', 'lastName', 'email', 'password'];
  const validateForm = (nextState) => {
    let isError = false;
    const data = ADVISOR_FORM_CHECK?.map((field, i, arr) => {
      if (formData?.[field] !== '') {
        if (
          field === 'password' &&
          passwordPattern.test(formData?.[field]) === false
        ) {
          isError = true;
          showMessage(INVALID_PASSWORD_MSG);
          return true;
        } else return false;
      }
      return true;
    });
    if (!isError) {
      if (data.includes(true)) {
        showMessage('Please fill all fields');
      } else {
        setStepNo(nextState);
      }
    }
  };

  const closeDisclaimerModal = () => { dispatch(toggleModal({ open: '' })); }
  const closeAddCompany = () => {
    setStep(1)
    setExistingCompany('');
    setWebsiteStatus('Check');
    setCompanyOptions([]);
    setSelectedCompany({});
    setConfirmedCompany();
    dispatch(toggleModal({ open: '' }));
  };

  const handleNotYourCompany = async () => {
    let requestBody = { companyNumber: confirmedCompany['company_number'] }
    const res = await postRequest(`/company/deleteGuestAddCompany`, requestBody);
    setStep(1);
    setCompanyOptions([]);
    setSelectedCompany({});
    setConfirmedCompany();
    await localStorage.removeItem('isDemoChecklist');
    await localStorage.removeItem('isPartnerChecklist');
    dispatch(toggleModal({ open: 'addCompany' }));
    if (res && res['code'] == 200) {
      setPreviousCompanyDeleted(true);
      showMessage(res['message']);
    } else setPreviousCompanyDeleted(false)
  };

  const handleChildCompany = async (el) => {
    if (!companiesGroup[el['companyId']]) companiesGroup[el['companyId']] = { companyId: el['companyId'] };
    if (el['selected']) companiesGroup[el['companyId']]['selected'] = el['selected'];
    if (el['group']) {
      document.getElementById(`group-${el['companyId']}`).value = el['group'];
      companiesGroup[el['companyId']]['group'] = el['group'];
    }
    if (el['percentage']) {
      document.getElementById(`percentage-${el['companyId']}`).value = el['percentage'];
      companiesGroup[el['companyId']]['percentage'] = el['percentage'];
    }
    if (el['event']?.['target']?.['checked'] == false) delete companiesGroup[el['companyId']];

    setCompaniesGroup(companiesGroup);
  };

  const handleCreateGroup = async () => {
    let isValid = true
    Object.keys(companiesGroup).map(key => {
      if (companiesGroup?.[key].percentage <= 100 && companiesGroup?.[key].percentage >= 0 && /^[a-zA-Z0-9\s]*$/.test(companiesGroup?.[key].percentage)) { }
      else { isValid = false }
    })
    if (isValid) {
      companiesGroup[parentCompany['_id']] = { companyId: parentCompany['_id'], group: 'Parent', selected: 'true' };
      let data = await Object.values(companiesGroup).filter(company => {
        if (!company['group']) company['group'] = 'Subsidiary';
        if (!company['percentage']) company['percentage'] = '0';
        if (company['selected'] == 'true') return company;
      });
      if (data && data.length > 1) {
        const res = await postRequest(`/company/addGroup`, { companiesGroup: data });
        if (res || res['code'] == 200) setTimeout(() => window.location.reload(), 500);
      }
      else showMessage("Please select a company for group");
    } else { showMessage("Please enter valid percentage ") }

  };

  const handleBugAttachmentFile = (e) => {
    if (e.target.files) {
      const newAttachment = Array.from(e.target.files);
      setAttachments((prev) => [...prev, ...newAttachment]);
    }
  };

  const onDragOverBug = (e) => e.preventDefault();
  const onDropBug = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files && files.length) {
      const event = {
        target: {
          files: files,
        },
      };
      handleBugAttachmentFile(event);
    }
  };

  const hideBugPopup = () => {
    setBugDescription("");
    setAttachment([]);
    dispatch(toggleModal({ open: "" }));
  };

  const deleteBugAttachment = async (targetFile) => {
    let updateAttachments = await attachment.filter(
      (file) => file.name !== targetFile.name
    );
    setAttachment(updateAttachments);
  };

  const handleSubmitBug = async () => {
    if (!bugDescription) return showMessage("Please add bug description!");
    const wordCount = bugDescription?.split(/\s+/).length;
    if (wordCount < 5)
      return showMessage("Please elaborate bug in minimum five words");
    let data;
    if (attachment) data = { attachment, bugDescription };
    else data = { bugDescription };
    let res = await postRequest("/user/reportBug", data);
    hideBugPopup()
    if (res || res["code"] == 200) {
      showMessage(res["message"]);
      dispatch(toggleModal({ open: "" }));
    }
  };

  const loggedInPopups = (
    <>

      {/* Resend Forgot Password email start */}
      <ResendForgotPasswordEmail modalType={"resendForgotPasswordEmail"} modalData={modal.historyData} />
      <PasswordUpdated modalType={"passwordUpdatedSuccessfully"} userData={user} modalData={modal.historyData} />

      {/* New Member */}
      <Modal id='newMemberPopUp' open={modal['open'] == 'newMember'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'>
        <>
          <div className={`mah70 oya bg1 shadow w100 bsbb df fdc m1rem maw700px br20px p2rem hideScrollbar`}>
            <h1 className='fs1-5rem w100 lh1 c15 fw500 tac my2rem'>Set New Password</h1>
            <div className='w100 df fdc jcc aic py1rem'>
              <div className='df jcc w100'>
                <input id='newMemberPassword' type={passwordType ? 'text' : 'password'} placeholder='New Password' className='w80 shadow bg5 br5px p1rem' />
                {passwordType ? (
                  <svg className="pr cp" onClick={() => setPasswordType(false)} width="27" height="21" viewBox="0 0 27 21" fill="none" xmlns="http:www.w3.org/2000/svg" style={{ top: '25px', transform: 'translateY(-50%)', right: "35px", }}>
                    <path d="M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z" fill="#404040" />
                  </svg>
                ) : (
                  <svg className="pr cp" onClick={() => setPasswordType(true)} width="27" height="21" viewBox="0 0 27 21" fill="none" xmlns="http:www.w3.org/2000/svg" style={{ top: '25px', transform: 'translateY(-50%)', right: "35px", }}>
                    <path d="M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z" fill="#404040" />
                    <path d="M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z" fill="#404040" />
                  </svg>
                )}
              </div>
              <button onClick={() => setMemberPassword()} className='new-shadow w50 br50px py0-75rem cp px2rem fw400 tac bg4 c1 my2rem'>Confirm</button>
            </div>
          </div>
          <svg className="pa cp" onClick={() => dispatch(toggleModal({ open: '' }))} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '25%' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
            <path d="M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z" fill="white" />
          </svg>
        </>
      </Modal>

      {/* Confirm Logout */}
      <ModalWrapper
        modalType={"confirmLogout"}
        onCloseHandler={handleLogoutClose}
        modalCardClasses={"maw500"}
      >

        <h1 className='c15 fs2rem tac lh1 fw600 mb2rem'>
          Confirmation
        </h1>
        <div className='logoutConfirmModal'>Are you sure you want to logout ?</div>
        <div className='df jcc gg1rem'>
          <Button
            type={"button"}
            onClick={handleLogoutClose}
            text={"Cancel"}
            btnType="default"
            textClassName="c1"
          />
          <Button
            type={"button"}
            btnType={"warning"}
            onClick={() => setLogout()}
            text={"Confirm"}
          />
        </div>

      </ModalWrapper>
    </>
  );

  const popups = (
    <>

      {/* Diligentsia Mobile Devices Popup */}
      <Modal open={modal['open'] == 'mobileDevicesPopup'} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
        <div className="mah90 bg1 shadow w100 px2rem py3rem bsbb df fdc aic m1rem maw800px pr pt5rem br20px pr">
          <img className="h2rem pa t0 l0 m1rem" src={require(`../../images/logo.svg`)} alt="TODO" />
          <h2 className='tac mb0-5rem c15 mb1rem'>Sorry, you can’t use Diligentsia from a mobile</h2>
          <div className="tac c12">
            {/* <img className="w100px h100px" src={require(`../../../../images/no-registration-icon.png`)} alt="" /> */}
            <p className='mb1rem c15 fs1rem px1rem op70'>Diligentsia works with your diligence files and therefore is designed to only work on your desktop or laptop computer.</p>
          </div>
          <Link onClick={() => dispatch(toggleModal({ open: '' }))} to={ROUTES.HOME} className={`w200px df jcc aic fw500 px1rem py0-5rem c1 bg4 br19px cp`}>Home</Link>
        </div>
      </Modal>

      {/* Buy Now on Pricing plan, Login or register alert Alert pop up */}
      <Modal
        id='alertBuyNowPopUp'
        open={modal['open'] === 'alertLoginPopUp'}
        onClose={() => dispatch(toggleModal({ open: '' }))}
        className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'
      >
        <div className='mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr' style={{ outline: 'none' }}>
          <button
            className='close-popup'
            onClick={() => dispatch(toggleModal({ open: '' }))}
          >
            <svg
              style={{ position: 'relative', top: '4px' }}
              className='pen fds h1rem f1 mr0-5rem'
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 320 512'
            >
              <path
                className='pen fa-primary'
                d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z'
              />
            </svg>
          </button>
          <h1 className='text-gradient fs2rem tac lh1 fw600 mb2rem'>
            <img className='py0-5rem h2rem' src={require(`../../images/logo.svg`)} alt='web-logo' />
          </h1>
          <div className='logoutConfirmModal'>
            To purchase a pack, please log in or register.
            Your account allows you to manage your purchases and
            access exclusive content. Thank you for choosing our service.
          </div>
          <div className='df gg1rem w100'>
            <Link to={ROUTES.LOGIN} style={{ height: '50px' }} onClick={() => { dispatch(toggleModal({ open: '' })); setIsBilling(true); }} className='bsbb jcc w60 df aic fw500 py0-5rem px1rem c1 bg3 br19px my1rem my0-xl cp mr1-5rem-xl'>
              Login
            </Link>
            <Link to={ROUTES.REGISTER} onClick={() => { localStorage.removeItem('registerAs'), dispatch(toggleModal({ open: '' })) }} className='bsbb jcc w40 df fdc aic fw500  px1rem c1 bg4 br19px cp registerButtonAnimation'
              style={{ height: '50px', width: '70%', paddingTop: '3px', paddingBottom: '3px' }}>
              <span>Register for FREE</span>
              <span className='fw400 c21 df fdc' style={{ marginTop: '-2px', fontSize: '10px', lineHeight: '15px', fontStyle: 'italic' }}>No credit card required</span>
            </Link>
          </div>
          <div className='w100 df jcc mt1-5rem'>
            <span style={{ height: '50px' }} onClick={() => dispatch(toggleModal({ open: '' }))} className='w40 br19px shadow td250 br5px p1rem fw600 cp ttu w50 bsbb tac mb1rem df jcc aic'>
              Cancel
            </span>
          </div>
        </div>
      </Modal>

      {/* Login */}
      <Modal open={modal['open'] == 'login'} className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'>
        <div className='mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr'>
          <button className='close-popup' onClick={() => dispatch(toggleModal({ open: '' }))}>
            <svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
              <path
                className='pen fa-primary'
                d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z'
              />
            </svg>
          </button>
          <h1 className='text-gradient fs2rem fw600 mb2rem'>Login</h1>
          <div className='df fdc gg1rem'>
            <div className='pr'>
              <input
                id='loginEmail'
                type='email'
                placeholder='Email'
                className='pl4rem shadow bg5 w100 br5px p1rem'
              />
              <svg
                className='center-vertically f3 pa l0 ml1rem w2rem'
                viewBox='0 0 512 512'
              >
                <path
                  d='M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z'
                  className='fa-secondary'
                ></path>
                <path
                  d='M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z'
                  className='fa-primary'
                ></path>
              </svg>
            </div>
            <div className='pr'>
              <input
                id='loginPassword'
                type='password'
                placeholder='Password'
                className='pl4rem shadow bg5 w100 br5px p1rem'
              />
              <svg
                className='center-vertically f3 pa l0 ml1rem w2rem'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 448 512'
              >
                <path
                  className='fa-primary'
                  d='M64 223.1h320c35.35 0 64 28.65 64 64v160c0 35.34-28.65 64-64 64H64c-35.35 0-64-28.66-64-64v-160C0 252.7 28.65 223.1 64 223.1z'
                />
                <path
                  className='fa-secondary'
                  d='M368 144V224h-64V144C304 99.88 268.1 64 224 64S144 99.88 144 144V224h-64V144c0-79.41 64.59-144 144-144S368 64.59 368 144z'
                />
              </svg>
            </div>
            <span
              onClick={() => { if (!loading) { login() } }}
              className={`shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic ${loading && 'button-disabled'}`}
            >
              Login
              <svg
                className='pen ml0-5rem h1rem f1'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 512 512'
              >
                <path
                  className='fa-primary'
                  d='M342.6 278.6l-128 128c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25L242.8 288H32C14.31 288 0 273.7 0 256s14.31-32 32-32h210.8L169.4 150.6c-12.5-12.5-12.5-32.75 0-45.25c12.49-12.49 32.74-12.51 45.25 0l128 128C355.1 245.9 355.1 266.1 342.6 278.6z'
                />
                <path
                  className='fa-secondary'
                  d='M416 32h-64c-17.67 0-32 14.33-32 32s14.33 32 32 32h64c17.67 0 32 14.33 32 32v256c0 17.67-14.33 32-32 32h-64c-17.67 0-32 14.33-32 32s14.33 32 32 32h64c53.02 0 96-42.98 96-96V128C512 74.98 469 32 416 32z'
                />
              </svg>
            </span>
            <div className='df jcsb fdc fdr-md aic'>
              <span className='c3-hover my0-5rem td250 fs1-25rem cp' data-scroll-to='RegisterSection' onClick={() => dispatch(toggleModal({ open: '' }))}>
                Create New Account
              </span>
              <span
                onClick={() =>
                  dispatch(toggleModal({ open: 'forgotPassword' }))
                }
                className='c4-hover my0-5rem td250 fs1-25rem cp'
              >
                Forgotten password?
              </span>
            </div>
          </div>
        </div>
      </Modal>

      {/* Forgot Password */}
      <Modal
        open={modal['open'] == 'forgotPassword'}
        onClose={() => dispatch(toggleModal({ open: '' }))}
        className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'
      >
        <div className='mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr'>
          <button
            className='close-popup'
            onClick={() => dispatch(toggleModal({ open: '' }))}
          >
            <svg
              style={{ position: 'relative', top: '4px' }}
              className='pen fds h1rem f1 mr0-5rem'
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 320 512'
            >
              <path
                className='pen fa-primary'
                d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z'
              />
            </svg>
          </button>
          <h1 className='text-gradient fs2rem tac lh1 fw600 mb2rem'>
            Forgot Password
          </h1>
          <div className='df fdc gg1rem'>
            <div className='pr'>
              <input
                id='forgotPasswordEmail'
                type='email'
                placeholder='Email'
                className='pl4rem shadow bg5 w100 br5px p1rem'
              />
              <svg
                className='center-vertically f3 pa l0 ml1rem w2rem'
                viewBox='0 0 512 512'
              >
                <path
                  d='M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z'
                  className='fa-secondary'
                ></path>
                <path
                  d='M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z'
                  className='fa-primary'
                ></path>
              </svg>
            </div>
            <span
              onClick={() => forgotPassword()}
              className='shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic'
            >
              Reset Password
              <svg
                className='pen ml0-5rem h1rem f1'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 512 512'
              >
                <path
                  className='fa-primary'
                  d='M336 0c-97.2 0-176 78.8-176 176c0 14.71 2.004 28.93 5.406 42.59l128 127.1C307.1 349.1 321.3 351.1 336 351.1c97.2 0 176-78.8 176-176S433.2 0 336 0zM376 176c-22.09 0-40-17.91-40-40S353.9 96 376 96S416 113.9 416 136S398.1 176 376 176z'
                />
                <path
                  className='fa-secondary'
                  d='M165.4 218.6l-156 156C3.371 380.6 0 388.8 0 397.3V496C0 504.8 7.164 512 16 512l96 0c8.836 0 16-7.164 16-16v-48h48c8.836 0 16-7.164 16-16v-48h57.37c4.242 0 8.312-1.688 11.31-4.688l32.72-32.72L165.4 218.6z'
                />
              </svg>
            </span>
            <span
              onClick={() => dispatch(toggleModal({ open: 'login' }))}
              className='c3-hover td250 fs1-25rem cp'
            >
              Back to Login
            </span>
          </div>
        </div>
      </Modal>

      {/* Register User */}
      <Modal open={modal['open'] == 'register'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'>
        <div className='bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr'>
          <button className='close-popup' onClick={() => dispatch(toggleModal({ open: '' }))} >
            <svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' >
              <path className='pen fa-primary' d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z' />
            </svg>
          </button>
          <h1 className='text-gradient fs2rem fw600'>Register</h1>
          <p className='mb0-5rem'>Please register using your company email</p>
          {user?.['role'] == 'Guest' && (<p className='mb2rem'>To store your reports – no credit card</p>)}
          <div className='df fdc gg1rem mt1rem'>
            <div className='pr'>
              <input id='registerFirstName' type='text' placeholder='First Name' className='pl4rem shadow bg5 w100 br5px p1rem' />
              <svg
                className='center-vertically f3 pa l0 ml1rem w2rem'
                viewBox='0 0 640 512'
              >
                <path d='M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z' className='fa-secondary' ></path>
              </svg>
            </div>
            <div className='pr'>
              <input id='registerLastName' type='text' placeholder='Last Name' className='pl4rem shadow bg5 w100 br5px p1rem' />
              <svg className='center-vertically f3 pa l0 ml1rem w2rem' viewBox='0 0 640 512' >
                <path d='M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z' className='fa-secondary' ></path>
              </svg>
            </div>
            <div className='pr'>
              <input id='registerEmail' type='email' placeholder='Email – please use your company email address' className='pl4rem shadow bg5 w100 br5px p1rem' />
              <svg className='center-vertically f3 pa l0 ml1rem w2rem' viewBox='0 0 512 512' >
                <path d='M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z' className='fa-secondary' ></path>
                <path d='M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z' className='fa-primary' ></path>
              </svg>
            </div>
            <div className='pr'>
              <input id='registerPassword' type='password' placeholder='Password' className='pl4rem shadow bg5 w100 br5px p1rem' />
              <svg className='center-vertically f3 pa l0 ml1rem w2rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' >
                <path className='fa-primary' d='M64 223.1h320c35.35 0 64 28.65 64 64v160c0 35.34-28.65 64-64 64H64c-35.35 0-64-28.66-64-64v-160C0 252.7 28.65 223.1 64 223.1z' />
                <path className='fa-secondary' d='M368 144V224h-64V144C304 99.88 268.1 64 224 64S144 99.88 144 144V224h-64V144c0-79.41 64.59-144 144-144S368 64.59 368 144z' />
              </svg>
            </div>
            <label for='registerTerms' className='py0-5rem df cp'>
              <span className='checkbox w2rem h2rem pr'>
                <input id='registerTerms' className='bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px' type='checkbox' />
              </span>
              <span className='w100 fs1rem lh3 ml1rem usn'>
                I agree to the &nbsp;
                <Link className='c3 c4-hover td250' href="/terms-conditions" target='_blank'> terms and conditions &nbsp; </Link> and &nbsp;
                <Link className='c3 c4-hover td250' href="/policy" target='_blank' > policies </Link>
              </span>
            </label>
            <span onClick={() => { if (!loading) register() }} className={`shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic  ${loading && 'button-disabled'}`} >
              Register
              <svg className='pen ml0-5rem h1rem f1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512' >
                <path className='fa-primary' d='M616 200h-48v-48C568 138.8 557.3 128 544 128s-24 10.75-24 24v48h-48C458.8 200 448 210.8 448 224s10.75 24 24 24h48v48C520 309.3 530.8 320 544 320s24-10.75 24-24v-48h48C629.3 248 640 237.3 640 224S629.3 200 616 200z' />
                <path className='fa-secondary' d='M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3C0 496.5 15.52 512 34.66 512h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z' />
              </svg>
            </span>
            <span onClick={() => dispatch(toggleModal({ open: 'login' }))} className='c3-hover td250 fs1-25rem cp' >
              Already have an account? Login
            </span>
          </div>
        </div>
      </Modal >

      {/* Register Verification */}
      <Modal
        open={modal['open'] == 'registerVerification'}
        onClose={() => dispatch(toggleModal({ open: '' }))}
        className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'
      >
        <div className='mah90 oya bg1 p3rem shadow w100 bsbb df fdc maw600px br5px pr'>
          <button
            className='close-popup'
            onClick={() => dispatch(toggleModal({ open: '' }))}
          >
            <svg
              style={{ position: 'relative', top: '4px' }}
              className='pen fds h1rem f1 mr0-5rem'
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 320 512'
            >
              <path
                className='pen fa-primary'
                d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z'
              />
            </svg>
          </button>
          <h2 className='c4 fs1-75rem ttu w100 tac mb1rem'>
            Email Verification
          </h2>
          <div className='df fdc fs1rem mb1rem'>
            {/* <p>
              Security and protection of your data is is important to us. To
              assist in this we use 2-factor authentication. The default method
              on Registration is email. You have been sent a verification email
              – please click on the link provided in that email. It may be in
              your email spam folder. Once verified, you will be taken to your
              login screen where you will be asked to login as normal. Later you
              can add alternative/additional methods of 2FA in your User Profile
              – SMS and/or your authenticator app.
            </p> */}
            <p>
              Security and protection of your data is is important to us. To
              assist in this we use 2-factor authentication. You will be required
              verification on every login. By clicking Next, you will be taken to
              your login screen where you will be asked to login. Later you can
              add alternative/additional methods of 2FA in your User Profile
              – SMS and/or your authenticator app.
            </p>
          </div>
          <div className='df jcc fdc fdr-md aic fs1rem px1rem'>
            <Link
              className='shadow my0-5rem bg3 bg4-hover c1 td250 br5px p0-5rem fw600 cp ttu w40 bsbb tac'
              to={ROUTES.LOGIN}
              onClick={() => dispatch(toggleModal({ open: '' }))}
            >
              Next
            </Link>
          </div>
        </div>
      </Modal >

      {/* Register Advisor/Investor */}
      <Modal
        open={modal['open'] == 'registerAdvisor' || modal['open'] == 'registerInvestor'}
        onClose={() => dispatch(toggleModal({ open: '' }))}
        className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'
      >
        <div className='bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr oya'>
          <button className='close-popup' onClick={() => closePopup()}>
            <svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
              <path
                className='pen fa-primary'
                d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z'
              />
            </svg>
          </button>
          <h1 className='text-gradient fs2rem fw600 tac w100 mb0-5rem'>
            <div>
              <div className='investorHeading'>Free {modal['open'] == 'registerAdvisor' ? 'Advisor ' : 'Investor '} Registration</div>
              <div className='cardText'>(No credit card required)</div>
            </div>
          </h1>
          <p className='mb0-5rem'>
            {modal['open'] == 'registerAdvisor'
              ? 'Please register as Advisor using your professional email'
              : modal['open'] == 'registerInvestor'
                ? <div style={{ textAlign: 'center' }}>Please provide your main fund/company name as registered at UK Companies House</div>
                : ''}{' '}
          </p>
          <div className='df fdc gg1rem'>
            {stepNo == 'Step1' ? (
              <>
                <div className='pr'>
                  <input
                    id='firstName'
                    name='firstName'
                    type='text'
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder='First Name'
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                  />
                  <svg
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                    viewBox='0 0 640 512'
                  >
                    <path
                      d='M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z'
                      className='fa-secondary'
                    ></path>
                  </svg>
                </div>
                <div className='pr'>
                  <input
                    id='lastName'
                    name='lastName'
                    type='text'
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder='Last Name'
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                  />
                  <svg
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                    viewBox='0 0 640 512'
                  >
                    <path
                      d='M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z'
                      className='fa-secondary'
                    ></path>
                  </svg>
                </div>
                <div className='pr'>
                  <input
                    id='email'
                    name='email'
                    type='email'
                    value={formData.email}
                    onChange={handleChange}
                    placeholder='Email'
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                  />
                  <svg
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                    viewBox='0 0 512 512'
                  >
                    <path
                      d='M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z'
                      className='fa-secondary'
                    ></path>
                    <path
                      d='M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z'
                      className='fa-primary'
                    ></path>
                  </svg>
                </div>
                <div className='pr'>
                  <input
                    id='password'
                    name='password'
                    type='password'
                    value={formData.password}
                    onChange={handleChange}
                    placeholder='Password'
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                  />
                  <svg
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 448 512'
                  >
                    <path
                      className='fa-primary'
                      d='M133.3 308.8C56.91 326.9 0 395.4 0 477.3C0 496.5 15.52 512 34.66 512H184L133.3 308.8zM314.7 308.8L264 512h149.3C432.5 512 448 496.5 448 477.3C448 395.4 391.1 326.9 314.7 308.8z'
                    />
                    <path
                      className='fa-secondary'
                      d='M176 288l32 56l-31.99 135.1L184 512h80l7.988-32.05L240 344l32-56H176zM224 0C153.3 0 96 57.25 96 128s57.25 128 128 128s128-57.25 128-128S294.8 0 224 0z'
                    />
                  </svg>
                </div>

                <div className='df jcc'>
                  <span
                    onClick={(Step2) => validateForm('Step2')}
                    className='shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt2rem'
                  >
                    Next
                  </span>
                </div>
              </>
            ) : stepNo == 'Step2' ? (
              <>
                <div className='pr mb1rem'>
                  <input
                    id='searchCompany'
                    name='firmName'
                    value={formData['firmName']}
                    onChange={handleChange}
                    onKeyUp={searchCompanyTimeout}
                    type='text'
                    placeholder='Search your Firm Name/Number'
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                  />
                  <svg
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 512 512'
                  >
                    <path
                      className='fa-primary'
                      d='M512 144v288c0 26.5-21.5 48-48 48h-416C21.5 480 0 458.5 0 432v-288C0 117.5 21.5 96 48 96h416C490.5 96 512 117.5 512 144z'
                    />
                    <path
                      className='fa-secondary'
                      d='M176 96H128V48C128 21.5 149.5 0 176 0h160C362.5 0 384 21.5 384 48V96h-48V48h-160V96z'
                    />
                  </svg>
                </div>
                {selectedCompany && selectedCompany['title'] ? (
                  <>
                    <div className='shadow bg5 br5px p1rem dg gg0-5rem mb1rem'>
                      <h2 className='c4 fs1-5rem ttu w100 tac'>Company Info</h2>
                      <span>
                        <b>Company Status:</b>{' '}
                        {selectedCompany['company_status'].toUpperCase()}{' '}
                      </span>
                      <span>
                        <b>Company Number:</b>{' '}
                        {selectedCompany['company_number']}{' '}
                      </span>
                      <span>
                        <b>Company Title:</b> {selectedCompany['title']}{' '}
                      </span>
                      <span>
                        <b>Company Date of Creation:</b>{' '}
                        {selectedCompany['date_of_creation']}{' '}
                      </span>
                      <span>
                        <b>Company Description:</b>{' '}
                        {selectedCompany['description']}{' '}
                      </span>
                      <span>
                        <b>Company Address:</b>{' '}
                        {selectedCompany['address_snippet']}{' '}
                      </span>
                    </div>
                    <span
                      onClick={() => { confirmAdvisorCompany() }}
                      className='shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem'
                    >
                      Confirm & Next
                    </span>
                    <span
                      onClick={() => setSelectedCompany({})}
                      className='c3 c4-hover td250 fs1-25rem cp'
                    >
                      Back
                    </span>
                  </>
                ) : companyOptions.length > 0 ? (
                  <>
                    {companyOptions.map((option, idx) => (
                      <div
                        key={`${idx}-random-new-${new Date().getTime()}`}
                        onClick={() => setSelectedCompany(option)}
                        className='cp df fww jcfs aic bg5 py0-5rem px1rem shadow br5px'
                      >
                        <span className='fw600 mr1rem'>{option['title']}</span>
                        <span className='mr1rem'>
                          {option['company_number']}
                        </span>
                        <span className='ttu fw600'>
                          {option['company_status']}
                        </span>
                      </div>
                    ))}
                    <div className='df jcse'>
                      <span
                        onClick={() => setStepNo('Step1')}
                        className='c3 c4-hover td250 fs1-25rem cp'
                      >
                        Back
                      </span>
                    </div>
                  </>
                ) : null}
              </>
            ) : stepNo == 'Step3' ? (
              <>
                <div className='pr'>
                  <input
                    id='firmName'
                    name='firmName'
                    value={formData['firmName']}
                    type='text'
                    onChange={handleChange}
                    placeholder='Firm Name'
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                  />
                  <svg
                    viewBox='0 0 1024 1024'
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                  >
                    <path
                      d='M564.2 138.8c0.1-10.3-10.5-17.4-20.6-13.9L212.7 243.6c-6 2.1-10 7.7-10 13.9v572.6h361.5V138.8zM359.8 716.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m135.8 357c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-87.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3V272zM838.2 338.3c0.1-5.5-3-10.5-7.9-13.1L613.4 211.6c-10.2-5.4-22.6 1.9-22.6 13.1v605.5h247.4V338.3z m-83.6 378c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z'
                      fill='#66AFFF'
                    />
                    <path d='M876 900.8H147.2c-8.4 0-15.2-8-15.2-17.7v-35.3c0-9.7 6.8-17.7 15.2-17.7H876c8.4 0 15.2 8 15.2 17.7v35.3c0 9.8-6.8 17.7-15.2 17.7z' />
                  </svg>
                </div>
                <div className='pr'>
                  <input
                    id='firmAddress'
                    name='firmAddress'
                    value={formData['firmAddress']}
                    type='text'
                    onChange={handleChange}
                    placeholder='Firm Address'
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                  />
                  <svg
                    viewBox='0 0 256 256'
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                  >
                    <g>
                      <g>
                        <path
                          className='fa-secondary'
                          d='M42.1,122.7h37.7v8.9H42.1V122.7L42.1,122.7z'
                        />
                        <path
                          className='fa-primary'
                          d='M42.1,147h37.7v8.9H42.1V147L42.1,147z'
                        />
                        <path d='M42.1,172h37.7v8.9H42.1V172L42.1,172z' />
                        <path d='M42.1,197.1h37.7v8.9H42.1V197.1L42.1,197.1z' />
                        <path d='M107.1,74.6h60.3v8.9h-60.3V74.6z' />
                        <path d='M107.1,103.7h32.6v8.9h-32.6V103.7z' />
                        <path d='M107.1,132.8h18.7v8.9h-18.7V132.8z' />
                        <path d='M200.1,145.3c0-9.3-7.6-17-17-17s-16.9,7.6-16.9,17c0,9.3,7.6,17,16.9,17C192.5,162.2,200.1,154.6,200.1,145.3z M183.1,153.4c-4.5,0-8.1-3.6-8.1-8.1c0-4.5,3.6-8.1,8.1-8.1c4.5,0,8.1,3.6,8.1,8.1C191.3,149.7,187.6,153.4,183.1,153.4z' />
                        <path d='M190,223c4.2-5.3,11.6-15,18.9-25.9c15.1-22.6,22.8-39.7,22.8-50.7c0-26.8-21.8-48.6-48.6-48.6s-48.6,21.8-48.6,48.6c0,11,7.7,28.1,22.8,50.7c7.3,10.9,14.7,20.6,18.9,25.9h-25.1h-25.7v-26.3h18.8v-8.9h-27.6V223h-19V96.8V50.5h51.4h27.8v38.9h8.9V41.7h-36.7V24.1H88.8v17.6v8.9v28.6h-53v17.6H24.3V223H10v8.9h14.2h64.6h8.9h19h34.6h30.2H246V223H190z M97.7,32.9h42.6v8.7H97.7V32.9z M44.7,88h42.6v8.7H44.7V88z M33.1,223V105.6h2.7h53V223H33.1z M143.4,146.4c0-21.9,17.8-39.7,39.8-39.7c21.9,0,39.8,17.8,39.8,39.7c0,17.1-26.1,53.8-39.8,71.1C169.5,200.2,143.4,163.5,143.4,146.4z' />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className='pr'>
                  <input
                    id='designation'
                    name='designation'
                    value={formData['designation']}
                    type='text'
                    onChange={handleChange}
                    placeholder='Your Designation'
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                  />
                  <svg
                    viewBox='0 0 367.004 367.004'
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                  >
                    <g>
                      <path
                        className='fa-primary'
                        d='M160.937,197.203c24.125,0,80.846-29.033,80.846-98.603c0-9.705-0.236-19.081-1.037-27.94
												c-1.313-17.427-4.883-32.872-13.768-44.71C215.578,9.838,195.629,0,160.937,0c-34.68,0-54.628,9.833-66.029,25.937
												C86.012,37.778,82.44,53.231,81.127,70.669c-0.799,8.856-1.035,18.229-1.035,27.932C80.092,168.17,136.812,197.203,160.937,197.203
												z M187.328,36.123c-2.355,5.951-3.535,8.926-5.891,14.877c-15.209-4.297-25.791-4.297-41,0c-2.355-5.951-3.533-8.926-5.891-14.877
												C153.566,30.365,168.308,30.365,187.328,36.123z M92.119,83.517c0.932,2.037,4.889,9.869,11.014,10.604
												c7.041,0.844,18.729-24.936,57.805-24.998c39.076,0.063,50.764,25.842,57.805,24.998c6.125-0.735,10.082-8.567,11.014-10.604
												c0.189,4.992,0.259,10.046,0.259,15.084c0,34.006-15.015,55.076-27.612,66.763c-15.871,14.726-33.492,20.071-41.465,20.071
												c-7.973,0-25.594-5.345-41.465-20.071c-12.598-11.687-27.612-32.757-27.612-66.763C91.86,93.562,91.93,88.509,92.119,83.517z'
                      />
                      <path
                        className='fa-primary'
                        d='M232.705,211.768c2.605-2.606,5.371-4.994,8.26-7.181c-11.223-6.117-22.109-11.933-29.153-15.697l-0.331-0.177
												c-1.982-1.059-4.403-0.847-6.169,0.541c-9.085,7.132-19.035,11.938-29.574,14.283c-1.861,0.414-3.391,1.738-4.066,3.521
												l-10.734,28.291l-10.734-28.291c-0.675-1.783-2.204-3.106-4.066-3.521c-10.539-2.346-20.489-7.152-29.573-14.283
												c-1.769-1.388-4.188-1.601-6.17-0.541c-17.138,9.158-58.25,31.302-69.829,39.106c-19.621,13.219-28.199,61.053-29.72,70.508
												c-0.15,0.938-0.064,1.898,0.253,2.793c0.703,1.982,18.709,48.548,149.84,48.548c5.933,0,11.627-0.098,17.105-0.28
												c0.481-6.064,3.029-11.993,7.657-16.622l31.512-31.511C203.113,271.581,208.833,235.64,232.705,211.768z'
                      />
                      <path
                        className='fa-secondary'
                        d='M336.396,219.546c-12.79-12.79-29.821-19.834-47.957-19.834c-18.135,0-35.166,7.044-47.955,19.834
												c-21.512,21.511-26.052,54.982-11.04,81.396l1.317,2.319l-37.284,37.284c-6.042,6.043-6.041,15.876,0.002,21.92
												c2.927,2.927,6.819,4.539,10.958,4.539c4.142,0,8.033-1.612,10.96-4.54l37.285-37.283l2.317,1.315
												c10.126,5.748,21.698,8.787,33.464,8.787c18.127,0,35.149-7.04,47.933-19.824c12.791-12.79,19.835-29.822,19.835-47.957
												C356.231,249.367,349.187,232.336,336.396,219.546z M319.779,298.842c-8.357,8.358-19.488,12.962-31.339,12.962
												c-11.851,0-22.982-4.603-31.341-12.962c-17.281-17.281-17.281-45.399,0-62.68c8.359-8.359,19.49-12.962,31.341-12.962
												c11.851,0,22.981,4.604,31.339,12.963c8.359,8.358,12.963,19.488,12.963,31.339S328.138,290.483,319.779,298.842z'
                      />
                    </g>
                  </svg>
                </div>
                <div className='pr'>
                  <Input
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                    name='phone'
                    country='GB'
                    international
                    placeholder='Your Phone Number'
                    withCountryCallingCode
                    value={formData['phone']}
                    onChange={handlePhoneChange}
                  />
                  <svg
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 384 512'
                  >
                    <path
                      className='fa-primary'
                      d='M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z'
                    />
                    <path
                      className='fa-secondary'
                      d='M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z'
                    />
                  </svg>
                </div>
                <div className='pr'>
                  {websiteStatus == 'Check' ? (
                    <input
                      type='button'
                      className='verify-btn shadow shadow bg9 c1 p1rem fw600 cp ttu'
                      value={websiteStatus}
                      onClick={() => verifyWebsite()}
                    />
                  ) : websiteStatus == 'Confirm' ? (
                    <>
                      <input
                        type='button'
                        className='verify-btn shadow shadow bg9 c1 p1rem mr6rem fw600 cp ttu'
                        value='Check'
                        onClick={() => verifyWebsite()}
                      />
                      <input
                        type='button'
                        className='verify-btn shadow shadow bg8 c1 p1rem fw600 cp ttu'
                        value={websiteStatus}
                        onClick={() => setWebsiteStatus('Confirmed')}
                      />
                    </>
                  ) : (
                    <input
                      type='button'
                      className='verify-btn shadow shadow bg7 c1 p1rem fw600 ttu'
                      value={websiteStatus}
                    />
                  )}
                  <input
                    id='companyWebsite'
                    name='website'
                    type='text'
                    value={formData['website']}
                    onChange={(e) => {
                      handleChange(e), setWebsiteStatus('Check');
                    }}
                    placeholder='Website'
                    className='pl4rem shadow bg5 w100 br5px p1rem'
                  />
                  <svg
                    viewBox='0 0 512 512'
                    className='center-vertically f3 pa l0 ml1rem w2rem'
                  >
                    <g>
                      <g>
                        <path
                          d='M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256s256-114.62,256-256S397.38,0,256,0z M172.211,41.609
													c-24.934,27.119-44.68,66.125-56.755,111.992H49.749C75.179,102.741,118.869,62.524,172.211,41.609z M25.6,256
													c0-26.999,5.077-52.727,13.662-76.8h70.494c-4.608,24.294-7.356,49.963-7.356,76.8s2.748,52.506,7.347,76.8H39.262
													C30.677,308.727,25.6,283,25.6,256z M49.749,358.4h65.707c12.083,45.867,31.821,84.872,56.755,111.991
													C118.869,449.476,75.179,409.259,49.749,358.4z M243.2,485.188c-43.81-8.252-81.877-58.24-101.359-126.788H243.2V485.188z
													M243.2,332.8H135.74c-4.924-24.166-7.74-49.997-7.74-76.8s2.816-52.634,7.74-76.8H243.2V332.8z M243.2,153.6H141.841
													C161.323,85.052,199.39,35.063,243.2,26.812V153.6z M462.251,153.6h-65.707c-12.083-45.867-31.821-84.873-56.755-111.992
													C393.131,62.524,436.821,102.741,462.251,153.6z M268.8,26.812c43.81,8.252,81.877,58.24,101.359,126.788H268.8V26.812z
													M268.8,179.2h107.46c4.924,24.166,7.74,49.997,7.74,76.8s-2.816,52.634-7.74,76.8H268.8V179.2z M268.8,485.188V358.4h101.359
													C350.677,426.948,312.61,476.937,268.8,485.188z M339.789,470.391c24.934-27.127,44.672-66.125,56.755-111.991h65.707
													C436.821,409.259,393.131,449.476,339.789,470.391z M402.244,332.8c4.608-24.294,7.356-49.963,7.356-76.8
													s-2.748-52.506-7.347-76.8h70.494c8.576,24.073,13.653,49.801,13.653,76.8c0,27-5.077,52.727-13.662,76.8H402.244z'
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className='pr mt0-5rem shadow p1rem bg5 '>
                  <label className='df mb0-5rem'>Firm Logo</label>
                  {formData['firmLogo'] == '' ? (
                    <label
                      onDragOver={onDragOver}
                      onDrop={(e) => onDrop(e)}
                      for='fileUpload'
                      className='w100 bsbb bg5 br5px df jcc aic px2rem py5rem bsd bo6 bw2px cp mb0-5rem'
                    >
                      <span className='pen fs1rem fw500 tac'>
                        Click here or drag and drop files (Max 160x160)
                      </span>
                      <input
                        onChange={handleImageChange}
                        className='dn'
                        id='fileUpload'
                        type='file'
                        accept='image/*'
                      />
                    </label>
                  ) : (
                    <>
                      <button
                        className='close-popup c3'
                        onClick={() =>
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            firmLogo: '',
                          }))
                        }
                      >
                        <svg
                          viewBox='0 0 256 256'
                          style={{ position: 'relative', top: '4px' }}
                          className='pen fds h1rem f1 mr0-5rem'
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  className='pen fa-primary'
                                  d='M94.6,3.6c-5.7,1.5-10.5,5.6-13.3,11.2l-1.7,3.4L79.5,28l-0.2,9.7H47.5c-30.4,0-32,0-33.7,0.9c-3.4,1.8-4.9,6.8-2.7,9.7c2.2,2.8,3.3,3.3,8.8,3.5c4.8,0.2,5.1,0.2,5.4,1.2c0.1,0.6,5.6,41.9,12.3,91.9c6.6,49.9,12.2,91.4,12.4,92c0.1,0.7,1,2.7,2,4.5c2.8,5.4,7.9,9.4,13.6,10.9c2.6,0.7,10.2,0.8,62.6,0.8c65.2,0,62.8,0.1,67.7-2.8c5.6-3.3,9.8-9.4,10.8-15.6c0.2-1.6,5.7-43,12.3-91.8c6.5-48.9,11.9-89.4,12-89.9c0.2-1,0.6-1,5.3-1.2c4.3-0.1,5.4-0.3,6.5-1.2c2.3-1.7,3.3-3.4,3.3-5.7c0-2.7-1.3-4.9-3.6-6.2c-1.8-1-2.3-1-33.8-1h-31.9l-0.2-9.7l-0.1-9.7l-1.7-3.4c-2.8-5.7-7.7-9.7-13.6-11.2C156.9,2.5,98.8,2.5,94.6,3.6z M159.3,18.1c2.8,1.7,3.1,2.9,3.1,11.8v7.9H128H93.7v-7.9c0-8.8,0.3-10.1,3.1-11.8c1.5-0.9,2.7-1,31.3-1C156.6,17.1,157.8,17.1,159.3,18.1z M216.3,55c-0.2,1.7-5.7,42.7-12.1,91.1c-9,67.4-11.9,88.3-12.6,89.4c-0.4,0.8-1.7,2-2.7,2.5c-1.9,1-1.9,1-60.9,1c-53.2,0-59.2-0.1-60.7-0.8c-3.6-1.7-2.6,4.2-15.7-93.9C45.1,95,39.6,54,39.5,53.3l-0.2-1.3H128h88.7L216.3,55z'
                                />
                                <path d='M78.2,70c-1.7,1-2.8,2.6-3.3,4.4c-0.1,0.6,1.8,32.8,4.4,71.4c3.9,57.9,4.8,70.5,5.5,72c2.6,5.3,9.9,5.2,12.5-0.1c0.9-1.8,0.8-3-3.8-72.7c-5.2-77.6-4.6-72.6-8.1-74.9C83.3,68.9,80.3,68.8,78.2,70z' />
                                <path d='M124.7,69.9c-0.9,0.4-2.1,1.5-2.6,2.4c-1,1.6-1,2.4-1,73.1c0,70.9,0,71.6,1,73.1c2.6,4.2,9.2,4.2,11.8,0c1-1.6,1-2.3,1-73.1s0-71.6-1-73.1C132.1,69.4,128,68.3,124.7,69.9z' />
                                <path d='M170.7,70.2c-3.5,2.3-2.9-2.7-8.1,74.8c-4.7,70-4.8,70.8-3.8,72.7c2.6,5.3,10,5.4,12.5,0.1c0.7-1.4,1.6-13.5,5.3-69.2c2.5-37.1,4.5-69.2,4.6-71.2c0.1-3.1,0-3.9-1-5.3C177.9,69,173.8,68.2,170.7,70.2z' />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </button>
                      <div className='df jcc'>
                        <img
                          className='poupup-img shadow brw5 tac'
                          src={formData['firmLogo']}
                          alt='Firm Logo'
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className='df jcse'>
                  <span
                    onClick={() => setStepNo('Step2')}
                    className='shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem'
                  >
                    Back
                  </span>
                  <span
                    onClick={() => handleRegister()}
                    className='shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem'
                  >
                    Register
                  </span>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </Modal >

      {/* Choose Auth Method */}
      <ChooseAuthMethodModal
        modalType={"chooseAuthMethod"}
        smsEnabled={smsEnabled}
        loginWithSMS={loginWithSMS}
        twoFaEnabled={twoFaEnabled}
        loginWithTwoFA={loginWithTwoFA}
        emailEnabled={emailEnabled}
        loginWithEmail={loginWithEmail}
      />

      {/* EnterCode */}
      <EnterCode
        buttonText={buttonText}
        isButtonDisabled={isButtonDisabled}
        modalType={"enterCode"}
        authMethod={authMethod}
        loading={loading}
        codeEntered={codeEntered}
        smsEnabled={smsEnabled}
        twoFaEnabled={twoFaEnabled}
        emailEnabled={emailEnabled}
        resendCode={resendCode}
        counter={counter}
        loginFor={loginFor}
      />

      {/* Add Company */}
      <AddCompanyModal
        modalType={'addCompany'}
        proceedCompany={proceedCompany}
        setIsFireWork={setIsFireWork}
        user={user}
        isURL={isURL}
        applicant={applicant}
        openWindow={openWindow}
        setCompany={setCompany}
        setConfirmedCompany={setConfirmedCompany}
        confirmedCompany={confirmedCompany}
        companyOptions={companyOptions}
        setCompanyOptions={setCompanyOptions}
        selectedCompany={selectedCompany}
        setSelectedCompany={setSelectedCompany}
        closeAddCompany={closeAddCompany}
        existingCompany={existingCompany}
        setExistingCompany={setExistingCompany}
        step={step}
        setStep={setStep}
        setPreviousCompanyDeleted={setPreviousCompanyDeleted}
        previousCompanyDeleted={previousCompanyDeleted}
      />

      {/* Add Applicant Manual Investor Match */}
      <ModalWrapper modalCardClasses={"m0rem"} modalType={"addApplicantPopup"}
        girlComponent={
          <div style={{ position: "relative", maxHeight: "90%", left: "-20px" }}>
            <img src={require('../../images/investor-manual-add/add-applicant-ai.png')} alt="inteligent-girl" className="girlImage" />
          </div>}>

        <h1 className="tac c15 fs2rem fw400 mb2rem">Add Applicant To Your  <br />  Investor<span className='c4'>Match</span> Index</h1>
        <div className='w100 df fdc'>
          {/* Frist Name and Last Name */}
          <div class='w100 df gg1rem mb0-5rem'>
            {['firstName', 'lastName'].map((item, idx) => (
              <TextField fullWidth type='text' placeholder={`Applicant ${item == 'firstName' ? 'first name' : 'last name'}`} value={applicant[item] || ''} onChange={(e) => setApplicant({ ...applicant, [item]: e.target.value })} className='w100 bss bw2px bo5 br5px p1rem'
                InputProps={{
                  style: { borderRadius: "10px", fontSize: '14px' },
                  startAdornment: (item == 'firstName') && <svg style={{ marginRight: '10px' }} width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 2C5.34314 2 4 3.34315 4 5C4 6.65683 5.34314 8 7 8C8.65683 8 10 6.65683 10 5C10 3.34315 8.65683 2 7 2ZM2.5 5C2.5 2.51472 4.51472 0.5 7 0.5C9.48528 0.5 11.5 2.51472 11.5 5C11.5 7.48528 9.48528 9.5 7 9.5C4.51472 9.5 2.5 7.48528 2.5 5ZM2.35986 11.4624C3.58257 10.6981 5.22507 10.25 7 10.25C8.77495 10.25 10.4174 10.6981 11.6402 11.4624C12.8522 12.22 13.75 13.3626 13.75 14.75C13.75 15.1642 13.4142 15.5 13 15.5C12.5858 15.5 12.25 15.1642 12.25 14.75C12.25 14.0664 11.8046 13.334 10.8452 12.7344C9.89627 12.1414 8.53878 11.75 7 11.75C5.46123 11.75 4.10372 12.1414 3.15485 12.7344C2.19543 13.334 1.75 14.0664 1.75 14.75C1.75 15.1642 1.41421 15.5 1 15.5C0.58579 15.5 0.25 15.1642 0.25 14.75C0.25 13.3626 1.14771 12.22 2.35986 11.4624Z" fill="black" /></svg>,
                }}
              />
            ))}
          </div>
          {/* Email */}
          <div class='w100 df gg1rem mb0-5rem'>
            <TextField fullWidth type='email' placeholder='Applicant email' value={applicant['email'] || ''} onChange={(e) => setApplicant({ ...applicant, email: e.target.value })}
              InputProps={{
                style: { borderRadius: "10px", fontSize: '14px' },
                startAdornment: <svg style={{ marginRight: '10px' }} width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.1875 0.375H1.8125C1.36495 0.375 0.935725 0.55279 0.619257 0.869257C0.30279 1.18572 0.125 1.61495 0.125 2.0625V9.9375C0.125 10.3851 0.30279 10.8143 0.619257 11.1307C0.935725 11.4472 1.36495 11.625 1.8125 11.625H14.1875C14.6351 11.625 15.0643 11.4472 15.3807 11.1307C15.6972 10.8143 15.875 10.3851 15.875 9.9375V2.0625C15.875 1.61495 15.6972 1.18572 15.3807 0.869257C15.0643 0.55279 14.6351 0.375 14.1875 0.375ZM13.9456 1.5L8.24187 6.045C8.07875 6.19688 7.92125 6.19688 7.72438 6.045L2.05437 1.5H13.9456ZM14.1875 10.5H1.8125C1.66332 10.5 1.52024 10.4407 1.41475 10.3352C1.30926 10.2298 1.25 10.0867 1.25 9.9375V2.29875L6.99312 6.87187C7.26606 7.13682 7.63087 7.28597 8.01125 7.28813C8.36973 7.28661 8.71398 7.1477 8.97312 6.9L14.75 2.29875V9.9375C14.75 10.0867 14.6907 10.2298 14.5852 10.3352C14.4798 10.4407 14.3367 10.5 14.1875 10.5Z"
                    fill="black"
                  />
                </svg>,
              }}
            />
          </div>
          {/* Register Applicant */}
          <div className='w100 df jcc my1rem'>
            <button disabled={applicant['firstName'] == '' || applicant['lastName'] == '' || applicant['email'] == ''} onClick={() => dispatch(toggleModal({ open: 'addCompany' }))}
              className={`df jcc cp c1 fw400 fs1rem br38px w300px py0-5rem ${applicant['firstName'] == '' || applicant['lastName'] == '' || applicant['email'] == '' ? 'cna bg12' : 'cp bg4'}`}>Register Applicant</button>
          </div>
        </div>
      </ModalWrapper>

      {/* Generating Description */}
      <Modal open={modal['open'] == 'generatingDescription'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic'>
        <>
          <div className='mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt2rem br5px pr'>
            <svg style={{ position: 'absolute', top: '12px', right: '12px' }} width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_5984_64080)">
                <path d="M42.804 16.5734C41.2029 14.9781 38.6151 14.9781 37.014 16.5734L24.8135 28.7738L20.7487 24.709C19.1476 23.1137 16.5598 23.1137 14.9587 24.709C13.3575 26.3101 13.3575 28.8979 14.9587 30.499L21.9185 37.4648C23.5196 39.0659 26.1074 39.0659 27.7086 37.4648L42.8099 22.3693C44.4051 20.7682 44.4051 18.1745 42.804 16.5734Z" fill="#4A67FF" />
              </g>
              <g clip-path="url(#clip1_5984_64080)">
                <path d="M1.19598 29.2118C2.79711 30.807 5.3849 30.807 6.98602 29.2118L19.1865 17.0114L23.2513 21.0762C24.8524 22.6714 27.4402 22.6714 29.0413 21.0762C30.6425 19.4751 30.6425 16.8873 29.0413 15.2862L22.0815 8.32039C20.4804 6.71926 17.8926 6.71926 16.2914 8.32039L1.19007 23.4158C-0.40514 25.017 -0.405142 27.6107 1.19598 29.2118Z" fill="#FC7785" />
              </g>
              <defs>
                <clipPath id="clip0_5984_64080">
                  <rect width="30.25" height="30.25" fill="white" transform="translate(13.75 11.8926)" />
                </clipPath>
                <clipPath id="clip1_5984_64080">
                  <rect width="30.25" height="30.25" fill="white" transform="matrix(-1 0 0 -1 30.25 33.8926)" />
                </clipPath>
              </defs>
            </svg>
            <div className='tac mb1rem' style={{ backgroundImage: `url(${require('../../images/aiWatermark.png')})`, backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: 'center' }}>
              {isFireWork
                ? <img className='h10rem' src={require(`../../images/firework.gif`)} alt='firework' />
                : <img className='h10rem' src={require(`../../images/wizard.gif`)} alt='wizard' />
              }
              <h2 className='w100 c15 tac fw500'>Setting up your company...</h2>
              <div className="my2rem tac">
                <ProgressBar isFireWork={isFireWork} />
              </div>
              <p className='c15 op60 tac maw600px mla mra fs14px'>
                We are also preparing a short summary of your company’s business activities that will personalize platform reporting.
              </p>
            </div>
            {(localStorage.getItem('isDemoChecklist') || localStorage.getItem('isPartnerChecklist')) &&
              <div className='img-box pa' style={{ top: '10px', right: '-300px' }}><img className="w80" src={require(`../../images/demo-checklist/add-company-step3.png`)} alt="" /></div>
            }
          </div>
          <svg className="pa cp" onClick={() => {
            dispatch(toggleModal({ open: '' }))
          }}
            style={{ left: '50%', transform: 'translateX(-50%)', bottom: '20px' }}
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
            <path d="M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z" fill="white" />
          </svg>
        </>
      </Modal>

      {/* Confirm Description */}
      <ModalWrapper
        modalType={"confirmDescription"}
        girlComponent={<div className='lg-dn confirmDescription1' style={{ position: 'relative' }}>
          {(!localStorage.getItem('isDemoChecklist') && !localStorage.getItem('isPartnerChecklist')) && <>
            <img src="https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/girl-1730109127115.webp" alt="messageLadie" className='girlImage' />
            <img onClick={() => {
              dispatch(toggleModal({ open: 'introVideo' }));
              dispatch(setModalHistory({ modalHistory: modal['open'], historyData: company }))
            }}
              src={require(`../../images/clicktohearme.webp`)}
              className='pa cp'
              alt='clickToHearMe'
              style={{
                maxWidth: "130px",
                zIndex: 99,
                top: "-210px",
                left: "15px"
              }} />
          </>}
        </div>}
      >
        <h1 className='fs1-5rem tas w100 lh1 c15 fw600 mb0-5rem'>
          Company Description
        </h1>
        <p className='c3 fs14px w100 tas mb1rem'>AI Generated</p>
        {editDescription ? (
          <>
            <div className='df fdc fs1rem'>
              <textarea
                defaultValue={company['companyDescription']}
                rows='8'
                style={{ resize: 'vertical' }}
                name='companyDescription'
                id='companyDescription'
                type='text'
                className='pl4rem bss bw2px bo5 w100 br5px p1rem'
              ></textarea>
            </div>
            <div className='df jcsb fdc fdr-md aic fs1rem px2rem'>
              <span
                onClick={() => setEditDescription(false)}
                className='shadow my1rem bg4 bg3-hover c1 td250 br5px p1rem fw600 cp ttu w40 bsbb tac'
              >
                Back
              </span>
              <span
                onClick={() => updateDescription()}
                className='shadow my1rem bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w40 bsbb tac'
              >
                Save
              </span>
            </div>
          </>
        ) : (
          <>
            {/* <FadeScroll > */}
            <div className='df fdc fs14px c43 oya' style={{ backgroundImage: `url(${require('../../images/aiWatermark.png')})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'contain', lineHeight: '1.8', paddingRight: '16px', maxHeight: "300px" }}>
              {company['companyDescription']}
            </div>
            {/* </FadeScroll> */}
            <p className='c4 fs11px fw500 w100 tas pt1rem my1rem'>
              You can later edit description in Company Settings
            </p>
            <div className='df jcc fdc aic fs1rem px2rem'>
              {isDescriptionLogin
                ? <span onClick={() => { dispatch(toggleModal({ open: 'login' })), setIsDescriptionLogin(false) }} className='my0-5rem bg4 bg4-hover c1 td250 br50px pt0-5rem pb0-5rem fw600 cp ttu pl6rem pr6rem mla mra bsbb tac df jcc aic'>Next</span>
                : <span onClick={() => proceedCompany(company)} className='my0-5rem bg4 bg4-hover c1 td250 br50px pt0-5rem pb0-5rem fw600 cp ttu pl6rem pr6rem mla mra bsbb tac df jcc aic'>Next</span>
              }
              <button type='button' onClick={() => handleNotYourCompany()} className='cp bg1 c14 mt0-5rem' style={{ fontSize: '12px' }}>
                Not your company? <span className='c3'>Try again!</span>
              </button>
            </div>
          </>
        )}

      </ModalWrapper>

      {/* No AI Modal */}
      <Modal open={modal['open'] == 'noAiModal'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'>
        <div className='mah90 oya bg1 p3rem shadow w100 bsbb df fdc maw600px br5px pr'>
          <button className='close-popup' onClick={() => dispatch(toggleModal({ open: '' }))}>
            <svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
              <path
                className='pen fa-primary'
                d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z'
              />
            </svg>
          </button>
          <h1 className='text-gradient fs2rem tac lh1 fw600 mb0-5rem'>No AI</h1>
          <p className='mb1rem'>
            Data Protection: Your privacy is our ultimate quest! To maximize the
            power of your responses and enhance our services, we've allied with
            an AI-powered wizards, Microsoft’s Bing and Chat GPT by OpenAI.
          </p>
          <p className='mb1rem'>
            This collaboration lets us wave the magic wand over some of the
            answers and information you provide us, transforming it into
            comprehensive reports. It's important to note that this adventure
            may involve sharing some of your responses to our questions (but NOT
            the contents of any files you upload if you later subscribe) with
            our AI comrade.
          </p>
          <p className='mb1rem'>
            While this means your responses may take a side-quest with this AI
            tool, rest assured, it doesn't wander off or change hands. It's
            solely to boost your reports’ quality and the AI won't store or
            re-use it. Your information's journey with Chat GPT is for one
            purpose alone - to supercharge the reports we craft for you.
          </p>
          <p className='mb1rem'>
            Where AI has been used to enhance our reports, our report has an
            underlying digital watermark to make this clear.
          </p>
          <p className='mb1rem'>
            By tapping 'Accept', you're giving your consent for this noble quest
            of your data. If our data protection quest raises any questions or
            if you'd like to delve deeper into our data handling practices, our
            communication scrolls are always open for you!“ Click here for
            further information.
          </p>
          <div className='btn-group df jsc'>
            <button className='shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu mr2rem w100 bsbb tac mb1rem df jcc aic'>No AI</button>
            <button disabled className='shadow op20 bg3-hover c1 bg3 td250 br5px py0-5rem px1rem fw600 usn cp ttu w100 bsbb tac mb1rem df jcc aic'>No AI please</button>
          </div>
        </div>
      </Modal>

      {/* New Advisor Added */}
      <Modal open={modal['open'] == 'newAdvisorAdded' || modal['open'] == 'newInvestorCompany'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic'>
        <div className='mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr'>
          <button className='close-popup' onClick={() => dispatch(toggleModal({ open: '' }))}>
            <svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
              <path className='pen fa-primary' d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z' />
            </svg>
          </button>
          <h1 className='fs1-5rem lh1 c15 fw600 mb0-5rem tac'>
            Access Granted to {' '}{location.pathname.includes('newAdvisorCompany') ? 'Advisor' : 'Investor'}{' '}
          </h1>
          <div className='df fdc gg1rem'>
            <p className='fs14px c43 oya pt1rem'>
              Many congratulations, {resNewAdvisor && resNewAdvisor['userFirstName']}! You have granted
              {resNewAdvisor && resNewAdvisor['permissionType'] == 'ALL' && ' all areas '}
              {resNewAdvisor && resNewAdvisor['permissionType'] == 'DASHBOARD' && ' dashboard (only) '}
              {resNewAdvisor && resNewAdvisor['permissionType'] == 'DASHBOARD & REPORT' && ' dashboard and reports '}
              access to {location.pathname.includes('newAdvisorCompany') ? 'advisor ' : 'investor '}
              {resNewAdvisor && `${resNewAdvisor['advisorFirstName']} (${resNewAdvisor['advisorEmail']}) `}
              for company {resNewAdvisor && resNewAdvisor['companyName']}.
            </p>
            {resNewAdvisor && resNewAdvisor['userType'] == 'newUser' && (
              <>
                <p className='fs14px c43 oya'>You now need to set a password for your own newly created account on the Diligentsia platform.</p>
                <Link to={`/reset_password/${resNewAdvisor['code']}`} onClick={() => dispatch(toggleModal({ open: '' }))} className='aic bg4 br19px bsbb c1 cp df fw500 jcc w200px mt1rem px1rem py0-5rem registerButtonAnimation' >
                  Set Password
                  <svg className='pen ml0-5rem h1rem f1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
                    <path className='fa-primary' d='M336 0c-97.2 0-176 78.8-176 176c0 14.71 2.004 28.93 5.406 42.59l128 127.1C307.1 349.1 321.3 351.1 336 351.1c97.2 0 176-78.8 176-176S433.2 0 336 0zM376 176c-22.09 0-40-17.91-40-40S353.9 96 376 96S416 113.9 416 136S398.1 176 376 176z' />
                    <path className='fa-secondary' d='M165.4 218.6l-156 156C3.371 380.6 0 388.8 0 397.3V496C0 504.8 7.164 512 16 512l96 0c8.836 0 16-7.164 16-16v-48h48c8.836 0 16-7.164 16-16v-48h57.37c4.242 0 8.312-1.688 11.31-4.688l32.72-32.72L165.4 218.6z' />
                  </svg>
                </Link>
              </>
            )}
            {resNewAdvisor && resNewAdvisor['userType'] == 'oldUser' && (
              <>
                <p className='fs14px c43 oya'>You can now login into your account to check the access to {location.pathname.includes('newAdvisorCompany') ? 'advisor' : 'investor'}.</p>
                <Link to='/login' onClick={() => dispatch(toggleModal({ open: '' }))} className='bsbb jcc w200px w9rem df aic fw500 px1rem py0-5rem mt1rem c1 bg4 br19px cp registerButtonAnimation'>
                  Login Now!
                </Link>
              </>
            )}
          </div>
        </div>
      </Modal>

      {/* Existing Investor */}
      <Modal open={modal['open'] == 'existingInvestor'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic' >
        <div className='mah90 bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px pr pt3rem br5px pr'>
          <button className='close-popup' onClick={() => { setExistingInvestor({}), setStepNo('Step2'), dispatch(toggleModal({ open: 'registerInvestor' })) }}>
            <svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
              <path className='pen fa-primary' d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z' />
            </svg>
          </button>
          <img className='h3rem pa t0 l0 m1rem' src={require(`../../images/logo.svg`)} alt='TODO' />
          <h1 className='text-gradient fw600 mt2rem'>{`Existing Investor - ${existingInvestor['cName']}`}</h1>
          <div className='tac my1rem oa'>
            <p className='fs1rem taj px0-5rem'>
              Hi {`${formData['firstName']} ${formData['lastName']}`}, <br />
              We will notify <b>{existingInvestor['contactName']} </b> of your wish to add your Diligentsia account and request that they grant you access. <br /><br />
              Please click below REQUEST to grant for access<br /> Kind Regards </p>
          </div>
          <div className='df jcse'>
            <button onClick={() => requestInvestorAccess()} className='bg3 c1 h100 mt0-5rem shadow td250 br5px px2rem fs1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic'>Request</button>
          </div>
        </div>
      </Modal>

      <ModalWrapper modalType={'advisorAccessGranted'}>
        <div className='tac'>
          <img className='h2rem m1rem ' src={require(`../../images/logo.svg`)} alt='TODO' />
        </div>
        <h1 className='c15 fw600 tac'>Access Granted</h1>
        <div className='tac my1rem oa'>
          <p className='fs1rem c15 px0-5rem'>
            Hi {user['firstName']}, <br />
            You have successfully granted access to <b>{`${advisorAccessData?.['userName']}`} </b> for <b>{advisorAccessData?.['companyName']}</b>. <br /><br />
            Kind Regards </p>
        </div>
        <div className='df jcse'>
          <Button
            onClick={handleToDashboard}
            text={"Dashboard"}
            btnType='warning'
          />
        </div>
      </ModalWrapper>

      {/* Investor Access Granted */}
      <Modal open={modal['open'] == 'accessGranted'} className='backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic' >
        <div className='mah90 bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw800px pr pt3rem br5px pr'>
          <a className='close-popup' onClick={() => dispatch(toggleModal({ open: '' }))} to='/investor-dashboard'>
            <svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
              <path className='pen fa-primary' d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z' />
            </svg>
          </a>
          <img className='h2rem pa t0 l0 m1rem' src={require(`../../images/logo.svg`)} alt='TODO' />
          <h1 className='text-gradient fw600'>Access Granted</h1>
          <div className='tac my1rem oa'>
            <p className='fs1rem taj px0-5rem'>
              Hi {accessGrantedData['contactName']}, <br />
              You have successfully granted access to <b>{`${accessGrantedData['userFirstName']} ${accessGrantedData['userLastName']}`} </b> for <b>{accessGrantedData['investorName']}</b>. <br /><br />
              Kind Regards </p>
          </div>
          <div className='df jcse'>
            <Link
              onClick={() => dispatch(toggleModal({ open: '' }))}
              to={
                !user || !user.role
                  ? '/login'
                  : user.role.toLowerCase() === 'advisor'
                    ? '/advisor-dashboard'
                    : user.role.toLowerCase() === 'user'
                      ? '/dashboard'
                      : '/investor-dashboard'
              }
              className='c3 td250 fs1-5rem cp tdu'
            >
              Dashboard
            </Link>
          </div>
        </div>
      </Modal>

      {/* Company Settings */}
      {/* <Modal open={modal['open'] == 'companySettings'} onClose={() => dispatch(toggleModal({ open: '' }))} className='backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic' >
        <div className='mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr'>
          <button className='close-popup' onClick={() => dispatch(toggleModal({ open: '' }))}>
            <svg style={{ position: 'relative', top: '4px' }} className='pen fds h1rem f1 mr0-5rem' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
              <path className='pen fa-primary' d='M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z' />
            </svg>
          </button>
          <img className='h2rem pa t0 l0 m1rem' src={require(`../../images/logo.svg`)} alt='TODO' />
          <h1 className='text-gradient fw600 pb1rem'>Company 	Settings</h1>
          <div className='tac my1rem'>
            <p>We have created a Company Settings module where all the core information about the company subscription, its various settings is centralised in one place for you to access and control your use of the platform. This includes UK Companies House registered information about the company, subscription and billing information, its address and website etc. It also enables control of which colleagues can access which modules on the platform​</p>
          </div>

          <button onClick={() => dispatch(toggleModal({ open: '' }))} className='h100 mt0-5rem mxa shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic'>
            Let’s get going!
          </button>
        </div>
      </Modal> */}

      {/* Check Access Company */}
      <Modal open={modal['open'] == 'checkAccessCompany'} className='backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic' >
        <div className='mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr'>
          <img className='h2rem pa t0 l0 m1rem' src={require(`../../images/logo.svg`)} alt='TODO' />
          <h1 className='fs1-5rem lh1 c15 fw600 mb0-5rem tac'>Company Created</h1>
          <div className='df fdc fs14px c43 oya py2rem'>
            <p>Well done! Your client company has been created with a Free subscription. You now have full access to the dashboard and can complete free modules. When you're ready to give your client access, click the "Activate Client Login" button on your client list.</p>
          </div>
          <div className='df jcc'>
            <button onClick={() => window.location.reload()} className='h100 mt0-5rem bg4 bg3-hover c1 td250 br35px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic'>Close</button>
          </div>
        </div>
      </Modal>

      {/* Disclaimer Popup */}
      <Modal open={modal['open'] == 'disclaimerModal'} className='backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic' >
        <div className='poppins-font-style disclaimer-modal mah100 bg1 shadow w100 df fdc m1rem pr br10px pr' style={{ outline: 'none', maxWidth: '560px', }}>
          <div className='w100'>
            <div className='header-area w100'>
              <div className='df jcsb w100 px2rem py0-5rem bsbb aic'>
                <div className='icon-area df aic'>
                  <svg className='back-btn-modal cp' width='22' height='16' viewBox='0 0 22 16' fill='none' xmlns='http://www.w3.org/2000/svg' onClick={() => closeDisclaimerModal()}>
                    <path d='M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z' fill='#151313' />
                  </svg>
                  <p className='c15 fs1-25rem fw500 ml2rem'>Disclaimer</p>
                </div>
                <svg className='fa-secondary' width='110' height='100' viewBox='0 0 137 105' fill='none' xmlns='http://www.w3.org/2000/svg' style={{ marginBottom: '-21px' }}>
                  <path d='M133.726 98.1522L82.8958 8.84552C79.7793 3.46246 74.2257 0.232422 67.9925 0.232422C61.7589 0.232422 56.2057 3.46246 53.1458 8.84552L2.25893 98.1522C-0.800945 103.536 -0.744224 109.882 2.31565 115.209C5.4326 120.536 10.9858 123.766 17.1623 123.766H118.879C125.056 123.766 130.552 120.536 133.669 115.209C136.786 109.882 136.786 103.536 133.726 98.1522ZM73.6591 88.689C73.6591 91.8056 71.1091 94.3557 67.9925 94.3557C64.8759 94.3557 62.3258 91.8056 62.3258 88.689V87.7825C62.3258 84.6655 64.8759 82.1158 67.9925 82.1158C71.1091 82.1158 73.6591 84.6655 73.6591 87.7825V88.689ZM73.6591 67.5524C73.6591 70.7258 71.1091 73.2191 67.9925 73.2191C64.8759 73.2191 62.3258 70.7258 62.3258 67.5524V42.2223C62.3258 39.1057 64.8759 36.5556 67.9925 36.5556C71.1091 36.5556 73.6591 39.1057 73.6591 42.2223V67.5524Z' fill='white' />
                </svg>
              </div>
            </div>
            <div className='disclaimer-box p2rem' style={{ height: '58vh', overflow: 'auto' }}>
              <div className='accordian-box'>
                <Accordion expanded={accordion == 'one'} onChange={() => setAccordion('one')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className='fw500'>No investment advice</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className='mah100 mya oya df fdc jcsb'>
                      Diligentsia does NOT give investment advice, nor do
                      we generate revenue from successful introductions via
                      our platform. Our model is to charge companies for
                      tools and database access. Once introduced, it is the
                      responsibility of the company and investors to proceed
                      or not with any transaction.
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion expanded={accordion == 'two'} onChange={() => setAccordion('two')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className='fw500'>No responsibility for unaudited self-certification</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className='mah100 mya oya df fdc jcsb'>
                      Diligentsia does NOT take responsibility for the
                      unaudited self-certification, which is indicative. Third
                      parties should undertake their own diligence. We
                      remind companies, however, that third parties may
                      seek to rely on information provided by companies in
                      completion of our modules and should do so accurately
                      and honestly with this in mind.
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion expanded={accordion == 'three'} onChange={() => setAccordion('three')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className='fw500'>No responsibility for diligence packs</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className='mah100 mya oya df fdc jcsb'>
                      Diligentsia does NOT take responsibility for the
                      contents of the self-audited diligence packs - we
                      merely provide the tools for their generation and
                      scoring. Parties looking for more assurance should
                      take additional external professional advice, “professional advice, via, for example, Diligentsia Pro PLUS.
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion expanded={accordion == 'four'} onChange={() => setAccordion('four')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className='fw500'>We don’t take commissions from lawyers & accountants </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className='mah100 mya oya df fdc jcsb'>
                      Diligentsia does NOT take commissions from
                      accountants and lawyers, nor do we ask for % of
                      monies raised from investors. We generate our
                      revenues from subscriptions and module charges on
                      companies subscribing to our platform.
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion expanded={accordion == 'five'} onChange={() => setAccordion('five')}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className='fw500'>We don’t share your data without your permission</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className='mah100 mya oya df fdc jcsb'>
                      Diligentsia provides opportunities for companies to
                      obtain professional assistance from third parties.
                      However, introductions are only made, and your data
                      is only shared with those third parties at your
                      instigation.
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className='df jcc fdc w100 aic'>
                <button onClick={() => handleDisclaimer()} className='bg15 bg14-hover w50 py1rem mt2rem c1 br80px cp td250 mb1rem'>Understood</button>
                <p className='w100 tac c15' style={{ color: '#505050', fontSize: '13px' }}>See our full <a target='_blank' href='/terms-conditions' className='c3'>terms and conditions</a>, and <a target='_blank' href='/policy' className='c3'>policies</a></p>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* Group Companies */}
      <CreateGroupInfo modalType={"groupCompanies"} />

      {/* Create Group */}
      <CreateGroupModal
        modalType={"createGroup"}
        handleCreateGroup={handleCreateGroup}
        setCompaniesGroup={setCompaniesGroup}
        companiesGroup={companiesGroup}
        companies={companies}
        parentCompany={parentCompany}
        setParentCompany={setParentCompany}
        handleChildCompany={handleChildCompany}
        user={user}
        profileClass={profileClass}
      />

      {/* REPORT A BUG  - POPUP */}
      <Modal open={modal["open"] == "report-bug"} onClose={() => dispatch(toggleModal({ open: "" }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
        <div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
          <button className="close-popup" onClick={() => hideBugPopup()}>
            <svg style={{ position: "relative", top: "4px" }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
              <path
                className="pen fa-primary"
                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
              />
            </svg>
          </button>
          <h1 className="text-gradient fs2rem tac lh1 fw600 mb2rem">{" "}Drop us a note</h1>
          <div className="pr mb1rem">
            <label>Send us a note or make a suggestions and we’ll get back to you as soon as we can.  Add a file if you need to.</label>
            <textarea
              rows="4"
              value={bugDescription}
              onChange={(e) => setBugDescription(e.target.value)}
              placeholder="Feel free to share your thoughts"
              className="bss bw2px bo5 w100 br5px p1rem mt1rem">
            </textarea>
          </div>
          <label
            onDragOver={onDragOverBug}
            onDrop={onDropBug}
            htmlFor="attachment"
            className="w100 bsbb bg5 br5px df jcc aic p1rem bsd bo6 bw2px cp"
          >
            <span className="pen fs1rem fw500 tac">
              Click here or drag and drop attachment (max 5MB)
            </span>
            <input
              type="file"
              id="attachment"
              multiple
              className="dn"
              onChange={handleBugAttachmentFile}
              // Remove accept to allow all file types, or customize
              accept=".pdf,.txt,image/jpeg,image/png,application/pdf"
            />
          </label>
          <div className="df fdc aic my1rem">
            {attachment && attachment.map((item, idx) => (
              <div className="df jcc br25px lh1 bg3 c1 px1rem fw600 mt0-5rem" key={item["name"]}>
                <a href={item} target="_blank">
                  <span className="py0-5rem pl0-5rem">{item["name"].substring(0, 20) + "..."}</span>
                </a>
                <svg onClick={() => deleteBugAttachment(item)} className="p0-5rem f9 w1rem h1rem cp" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                  <path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32.0 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                </svg>
              </div>
            ))}
          </div>
          <div className="df jcse">
            <span onClick={() => dispatch(toggleModal({ open: "" }))} className="shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem">Cancel</span>
            <span onClick={() => handleSubmitBug()} className="shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem">Submit</span>
          </div>
        </div>
      </Modal>

      {/* Intro Video */}
      <Modal open={modal['open'] == 'introVideo'} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
        <div className='df jcc onone w60'>
          <div className={`mah90 w100 bsbb df fdc m1rem br20px pr`} style={{ background: 'transparent' }}>
            <div className="df jcsb aic fdc step-box-modal">
              <div className='step-box-box-1 tac w100'>
                <div className="pr cp">
                  <video
                    id="videoPaul"
                    onClick={(e) => setIsPlay(true)}
                    className="w100 br20px"
                    controls="true"
                    poster={"https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Intelligentsia, Video-1731405158175.webp"}
                  >
                    <source src={"https://d37hh65ee5l5bx.cloudfront.net/avatar/Intro+to+Intelligentsia.mp4"} type="video/mp4"></source>
                  </video>
                  <svg onClick={(e) => playVideo(e)} className={`${isPlay && 'dn'}  pa center`} style={{ width: '80px', height: '80px' }} width="146" height="146" viewBox="0 0 146 146" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M73.1295 0.384033C33.2267 0.384033 0.767578 32.8463 0.767578 72.7459C0.767578 112.646 33.2267 145.108 73.1295 145.108C113.032 145.108 145.491 112.646 145.491 72.7459C145.491 32.8463 113.032 0.384033 73.1295 0.384033ZM101.896 75.2811L59.6854 102.417C59.1908 102.738 58.6195 102.897 58.0542 102.897C57.5595 102.897 57.0589 102.773 56.6115 102.529C55.6397 101.999 55.039 100.986 55.039 99.8816V45.6102C55.039 44.5061 55.6397 43.4931 56.6115 42.9631C57.5654 42.439 58.7608 42.4712 59.6854 43.075L101.896 70.2107C102.756 70.7642 103.28 71.7213 103.28 72.7459C103.28 73.7706 102.756 74.7274 101.896 75.2811Z" fill="white" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <svg className="pa cp" onClick={() => { dispatch(toggleModal({ open: (modal && modal.modalHistory ? modal.modalHistory : '') })) }} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '100px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
            <path d="M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z" fill="white" />
          </svg>
        </div>
      </Modal >
    </>
  );

  useEffect(() => {
    // Initialize Intercom on component mount
    intercom();

    const handleHashChange = () => {
      if (window.location.hash === '#chat') {
        setTimeout(() => {
          if (window.Intercom) {
            window.Intercom('show');
          }
        }, 1000);
      }
    };

    handleHashChange(); // Check hash on initial load
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  let { data, totalFile, type } = useSelector(state => state.fileManagement);

  return (
    <>
      {intercom()}
      {popups}
      {loggedInPopups}
      {modal['open'] == 'importSummary' && <ImportSummaryModal modalType={"importSummary"} />}

      <FileLoaderModal modalType={"computerToDataRepository"} />
      <FileLoaderModal modalType={"computerToClarence"} />
      <FileLoaderModal modalType={"fileUploadFilingAssistant"} />

      <OpenRModal />

      <div id='popup-message' style={{ zIndex: '10000' }} className='zi5 shadow hidden bg4 c1 td500 pf b0 l0 mb2rem btrr5px bbrr5px pt0-5rem pb0-5rem pl1rem pr1rem fs1-5rem fw600'></div>
      {tooltip && (<div id={tooltip.id} className='shadow pen td100 pf p0-5rem br5px c6 fw500 backdrop zi5 px0-5rem py0-5rem' style={{ zIndex: '1500', top: tooltip.y + 'px', left: tooltip.x + 'px', background: '#fff' }} dangerouslySetInnerHTML={{ __html: tooltip.html }}></div>)}

      {
        totalFile > 0 || type == "syncingFolders" ? <SyncingProgress data={data} totalFile={totalFile} /> : ''
      }


    </>
  );
}
